import OtherHeader from "../components/otherheader";
import user from "../assets/images/review.svg";
import exportSvg from "../assets/images/export.svg";
import document from "../assets/images/document-text.svg";
import loaders from "../assets/images/load.svg";
import { useLocation, useNavigate, useParams } from "react-router";
import { useEffect, useState } from "react";
import document2 from "../assets/images/documentagree.svg";
import loaders2 from "../assets/images/refresh-square-2.svg";
import empty from "../assets/images/emptyadmin.svg";
import axios from "axios";
import sendfunds from "../assets/images/sendfunds.svg";
import rejectimg from "../assets/images/cancelsuccess.svg";
import checkbox from "../assets/images/marksuccess.svg";
import Loading, { PageLoader } from "../components/loading";
import factoring from "../assets/images/factoring.svg";
import US from "../assets/images/EU.svg";
import NGN from "../assets/images/ngnnigeria.jpg";
import EU from "../assets/images/usds.svg";
import GBP from "../assets/images/GB.svg";
import currencyPairCheck from "../components/logoCurrency";
import AmountCheck from "../components/amountcheck";
import DeclineRequestModal from "./rejectRequestModal";
import CancelLoanModal from "./cancelLoanModal";

import AcceptLoanRequest from "./approveLoanRequestModal";
import AcceptPaymentModal from "./acceptPaymentsRequest";
import RejectPaymentModal from "./rejectPaymentRequest";
import { ChevronRight } from "lucide-react";
import DisburseFundsModal from "./disburseFundsModal";
import Preview from "./previewPurchase";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import { resolveFinanceRouteState } from "../utils/routeStateResolvers";
import { formatMoney } from "../components/formatCurrency";

const financeTypes = {
  inventory_finance: "Inventory finance",
  payable_finance: "Payables finance",
  receivable_finance: "Receivables finance",
  payment_finance: "Payment finance",
};

const ManagementFeeSource = {
  TRADEVU: 'Deduct from wallet',
  FINANCE: 'Deduct from loan'
}

export const financeOptions = [
  {
    value: "purchaseOrder",
    label: "Purchase order",
  },
  {
    value: "transaction",
    label: "Reverse factoring",
  },
  {
    value: "freightPayment",
    label: "Freight",
  },
]

export const managementFinanceOptions = [
  {
    value: "fromLoan",
    label: "Deduct from loan",
  },
  {
    value: "separate",
    label: "Pay separately",
  },
];

const FileDisplay = ({ url, maxWidth = "200px" }) => {
  const getFilename = (url) => {
    try {
      if (!url) return "";

      const urlParts = typeof url === 'string' ? url?.split("/") : url?.url?.split("/");
      let filename = urlParts[urlParts.length - 1];

      filename = filename?.split("_")[0];

      return filename;
    } catch (error) {
      return "";
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
      }}
    >
      <div
        style={{
          width: "40px",
          height: "40px",
          backgroundColor: "#EEF4FF",
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img src={document} alt="" />
      </div>
      <p
        style={{
          fontSize: "15px",
          fontWeight: "500",
          color: "#101828",
          margin: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: maxWidth,
        }}
      >
        {getFilename(url)}
      </p>
    </div>
  );
};

const FinanceDetails = () => {
  const location = useLocation();
  const { id } = useParams();
  const [resolvedState, setResolvedState] = useState(location.state || null);
  const state = resolvedState || location.state || {};
  const navigate = useNavigate();
  const [tab, settab] = useState("kyc");
  const [loans, setLoans] = useState([]);
  const [showPreview, setShowPreview] = useState(false);

  const [allbusiness, setallbusiness] = useState([]);
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [loader, setloader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [success, setsucess] = useState(false);
  const [fail, setfail] = useState(false);
  const [message, setmessage] = useState("");
  const [idloan, setidloan] = useState("");
  const [businesswallet, setBusinesswallet] = useState([]);
  const [agreementDocument, setagreementDocument] = useState([]);
  const [isLoadingDocument, setisLoadingDocument] = useState(true);
  const [showDeclineModal, setShowDeclineModal] = useState({
    show: false,
    data: null,
  });
  const [showCancelLoanModal, setShowCancelLoanModal] = useState({
    show: false,
    data: null,
  });
  const [showLoanModal, setShowLoanModal] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [showDisburseFunds, setShowDisburseFunds] = useState(false);
  const [showRejectPayment, setShowRejectPayment] = useState(false);

  const statusColors = {
    pending: "#6F739B",
    disbursed: "#11A811",
    draft: "#DB6704",
  };
  const statusColorsP = {
    pending: "#DB6704",
    disbursed: "#11A811",
    draft: "#DB6704",
    approved: "#11A811",
  };
  const statusDisplayMap = {
    pending: "Processing",
    draft: "Draft",
    approved: "Pending disbursal",
    rejected: "Rejected",
    disbursed: "Disbursed",
    repaid: "Repaid",
    due: "Due",
    cancelled: "Cancelled",
  };

  useEffect(() => {
    if (allbusiness?.repayments?.length) {
      settab('repayment')
    }
  }, [allbusiness?.repayments?.length])

  useEffect(() => {
    let isMounted = true;

    const hydrateRouteState = async () => {
      if (location.state?._id && location.state?.customtype) {
        setResolvedState(location.state);
        return;
      }

      const nextState = await resolveFinanceRouteState(id, location.state);
      if (isMounted && nextState) {
        setResolvedState(nextState);
      }
    };

    hydrateRouteState();

    return () => {
      isMounted = false;
    };
  }, [id, location.state]);

  const getFilename = (url) => {
    try {
      if (!url) return "";

      const urlParts = url?.split("/");
      let filename = urlParts[urlParts.length - 1];
      filename = filename?.split("_")[0];

      return filename;
    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    if (fail) {
      let timer = setTimeout(() => {
        setfail(false);
      }, 3000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [fail]);

  useEffect(() => {
    if (success) {
      let timer = setTimeout(() => {
        setsucess(false);
      }, 3000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [success]);

  function allSigned() {
    if (agreementDocument.length !== 0) {
      const signees = agreementDocument.signees;
      for (const signee of signees) {
        if (signee.status !== "completed") {
          return false;
        }
      }
      return true;
    }
  }

  function anySigned() {
    if (agreementDocument.length !== 0) {
      if (
        agreementDocument.signees.length > 0 &&
        agreementDocument.signees[0].status === "completed"
      ) {
        return true;
      } else {
        return false;
      }

      // Loop through each signee
      /**
            for (const signee of agreementDocument.signees) {
              // Check if the status is "signed"
              if (signee.status === "completed") {
                // If any signee has status "signed", return true
                return true;
              }
            }
            **/
      // If no signee has status "signed", return false
      return false;
    }
  }
  useEffect(() => {
    const fetchLoanDetails = async () => {
      if (!state?._id || !state?.customtype) return;
      setIsLoading(true);
      await axios
        .get(
          `/v1/admin/loan/finance/${state._id}?financeType=${state.customtype === "Working Capital"
            ? "TradeCredit"
            : state.customtype === "Credit Line"
              ? "CreditLine"
              : "FinanceInvoice"
          }`
        )
        .then((res) => {
          setLoans(res.data.data?.loans);
          setidloan(res.data.data?._id);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          setIsLoading(false);
        });
    };
    fetchLoanDetails();
  }, [state?._id, state?.customtype]);
  const filterloan = loans?.filter((item) =>
    item?.paymentStatus?.match("UNPAID")
  );
  const filterloanrepaid = loans?.filter((item) =>
    item?.paymentStatus?.match("REPAID")
  );
  let firstloan = filterloan?.filter((item, index) => {
    return index === 0;
  });
  function areAllDocumentsApproved(uploadDocuments) {
    for (const key in uploadDocuments) {
      if (uploadDocuments[key]?.status !== "APPROVED") {
        return false;
      }
    }
    return true;
  }

  function checkDocumentsStatus(customtype) {
    if (customtype === "Credit Line") {
      return areAllDocumentsApproved(allbusiness.uploadDocuments);
    } else if (customtype === "Working Capital") {
      if (allbusiness.type === "purchaseOrder") {
        return areAllDocumentsApproved(allbusiness.purchaseOrder);
      } else if (allbusiness.type === "shippingDocuments") {
        return areAllDocumentsApproved(allbusiness.shippingDocuments);
      } else if (allbusiness.type === "inventoryDocuments") {
        return areAllDocumentsApproved(allbusiness.inventoryDocuments);
      } else if (allbusiness.type === "cashFlowSupport") {
        return areAllDocumentsApproved(allbusiness.cashFlowSupport);
      } else {
        return false;
      }
    } else if (customtype === "Factoring") {
      const agreement = allbusiness.agreement;
      const invoiceDocument = allbusiness.invoiceDocument;
      const extractedData = [agreement, invoiceDocument];

      return areAllDocumentsApproved([...extractedData]);
    } else {
      return false;
    }
  }

  function isAnyDocumentRejected(uploadDocuments) {
    // Iterate over the values of uploadDocuments object
    for (const key in uploadDocuments) {
      // Check if the status of the document is not 'APPROVED'
      if (uploadDocuments[key].status === "REJECTED") {
        // If any document has a status other than 'APPROVED', return false
        return true;
      }
    }
    // If no document has 'rejected' status, return false
    return false;
  }

  function checkDocumentsStatusisany(customtype) {
    // Check if the customtype is 'creditLine'
    if (customtype === "Credit Line") {
      // Use the function to check if all documents are approved
      return isAnyDocumentRejected(allbusiness.uploadDocuments);
    } else if (customtype === "Working Capital") {
      if (allbusiness.type === "purchaseOrder") {
        return isAnyDocumentRejected(allbusiness.purchaseOrder);
      } else if (allbusiness.type === "shippingDocuments") {
        return isAnyDocumentRejected(allbusiness.shippingDocuments);
      } else if (allbusiness.type === "inventoryDocuments") {
        return isAnyDocumentRejected(allbusiness.inventoryDocuments);
      } else if (allbusiness.type === "inventoryDocuments") {
        return isAnyDocumentRejected(allbusiness.cashFlowSupport);
      }
    } else {
      return false;
    }
  }
  const sendLenderDocument = () => {
    if (checkDocumentsStatus(state.customtype) === true) {
      navigate("/finance/review", {
        state: {
          ...allbusiness,
          customtype: state.customtype,
          ...state,
        },
      });
    }
  };

  const gotoDocuments = async () => {
    startVerification("PROCESSING");
    if (state.customtype === "Factoring") {
      if (
        allbusiness.agreement?.status === "APPROVED" &&
        allbusiness.invoiceDocument.status === "APPROVED"
      ) {
        navigate("/lender/agreement", {
          state: {
            ...allbusiness,
            customtype: state.customtype,
            ...state,
          },
        });
      }
      if (!allbusiness.invoiceDocument?.hasOwnProperty("status")) {
        navigate("/finance/document", {
          state: {
            image: allbusiness?.invoiceDocument?.url,
            type: "invoice",
            id: state._id,
            name: "Invoice",
            customtype: state.customtype,
          },
        });
      } else if (!allbusiness.agreement?.hasOwnProperty("status")) {
        navigate("/finance/document", {
          state: {
            image: allbusiness?.agreement?.url,
            type: "agreement",
            id: state._id,
            name: "Invoice",
            customtype: state.customtype,
          },
        });
      }
    }
    if (state.customtype === "Credit Line") {
      if (
        allbusiness?.uploadDocuments?.bankStatement?.status === "APPROVED" &&
        allbusiness?.uploadDocuments?.boardResolution?.status === "APPROVED" &&
        allbusiness?.uploadDocuments?.contractAgreement?.status ===
        "APPROVED" &&
        allbusiness?.uploadDocuments?.managementAccounts?.status ===
        "APPROVED" &&
        allbusiness?.uploadDocuments?.schedulingExistingLoan?.status ===
        "APPROVED"
      ) {
        navigate("/finance/review", {
          state: {
            ...allbusiness,
            customtype: state.customtype,
            ...state,
          },
        });
      } else {
        if (allbusiness?.uploadDocuments.bankStatement?.status === "PENDING") {
          navigate("/finance/document", {
            state: {
              image: allbusiness?.uploadDocuments?.bankStatement?.url,
              type: "bankStatement",
              id: state._id,
              name: "letterOfCredit",

              customtype: state.customtype,
              newdata: allbusiness,
            },
          });
        } else if (
          allbusiness?.uploadDocuments.boardResolution?.status === "PENDING"
        ) {
          navigate("/finance/document", {
            state: {
              image: allbusiness?.uploadDocuments?.boardResolution?.url,
              type: "boardResolution",
              id: state._id,
              name: "letterOfCredit",
              customtype: state.customtype,
              newdata: allbusiness,
            },
          });
        } else if (
          allbusiness?.uploadDocuments.contractAgreement?.status === "PENDING"
        ) {
          navigate("/finance/document", {
            state: {
              image: allbusiness?.uploadDocuments?.contractAgreement?.url,
              type: "contractAgreement",
              id: state._id,
              name: "letterOfCredit",
              customtype: state.customtype,
              newdata: allbusiness,
            },
          });
        } else if (
          allbusiness?.uploadDocuments.managementAccounts?.status === "PENDING"
        ) {
          navigate("/finance/document", {
            state: {
              image: allbusiness?.uploadDocuments?.managementAccounts?.url,
              type: "managementAccounts",
              id: state._id,
              name: "letterOfCredit",
              customtype: state.customtype,
              newdata: allbusiness,
            },
          });
        } else if (
          allbusiness?.uploadDocuments.schedulingExistingLoan?.status ===
          "PENDING"
        ) {
          navigate("/finance/document", {
            state: {
              image: allbusiness?.uploadDocuments?.schedulingExistingLoan?.url,
              type: "schedulingExistingLoan",
              id: state._id,
              name: "letterOfCredit",
              customtype: state.customtype,
              newdata: allbusiness,
            },
          });
        }
      }
    }
    if (state.customtype === "Working Capital") {
      if (allbusiness.type === "purchaseOrder") {
        if (
          allbusiness.purchaseOrder.bankStatement?.status === "APPROVED" &&
          allbusiness.purchaseOrder.boardResolution?.status === "APPROVED" &&
          allbusiness.purchaseOrder.contractAgreement?.status === "APPROVED" &&
          allbusiness.purchaseOrder.pastPurchaseOrder?.status === "APPROVED" &&
          allbusiness.purchaseOrder.purchaseOrder?.status === "APPROVED" &&
          allbusiness.purchaseOrder.vendorLetter?.status === "APPROVED"
        ) {
          navigate("/finance/review", {
            state: {
              ...allbusiness,
              customtype: state.customtype,
              ...state,
            },
          });
        } else {
          if (
            !allbusiness.purchaseOrder.boardResolution?.hasOwnProperty("status")
          ) {
            navigate("/finance/document", {
              state: {
                image: allbusiness?.purchaseOrder?.boardResolution?.url,
                type: "boardResolution",
                id: state._id,
                name: "TradeCredit",
                customtype: state.customtype,

                newdata: allbusiness,
              },
            });
          } else if (
            !allbusiness.purchaseOrder.contractAgreement?.hasOwnProperty(
              "status"
            )
          ) {
            navigate("/finance/document", {
              state: {
                image: allbusiness?.purchaseOrder?.contractAgreement?.url,
                type: "contractAgreement",
                id: state._id,
                name: "TradeCredit",
                newdata: allbusiness,
                customtype: state.customtype,
              },
            });
          } else if (
            !allbusiness.purchaseOrder.bankStatement?.hasOwnProperty("status")
          ) {
            navigate("/finance/document", {
              state: {
                image: allbusiness?.purchaseOrder?.bankStatement?.url,
                type: "bankStatement",
                id: state._id,
                name: "TradeCredit",
                newdata: allbusiness,
                customtype: state.customtype,
              },
            });
          } else if (
            !allbusiness.purchaseOrder.pastPurchaseOrder?.hasOwnProperty(
              "status"
            )
          ) {
            navigate("/finance/document", {
              state: {
                image: allbusiness?.purchaseOrder?.pastPurchaseOrder?.url,
                type: "pastPurchaseOrder",
                id: state._id,
                name: "TradeCredit",
                newdata: allbusiness,
                customtype: state.customtype,
              },
            });
          } else if (
            !allbusiness.purchaseOrder.purchaseOrder?.hasOwnProperty("status")
          ) {
            navigate("/finance/document", {
              state: {
                image: allbusiness?.purchaseOrder?.boardResolution?.url,
                type: "purchaseOrder",
                id: state._id,
                name: "TradeCredit",
                newdata: allbusiness,
                customtype: state.customtype,
              },
            });
          } else if (
            !allbusiness.purchaseOrder.vendorLetter?.hasOwnProperty("status")
          ) {
            navigate("/finance/document", {
              state: {
                image: allbusiness?.purchaseOrder?.vendorLetter?.url,
                type: "vendorLetter",
                id: state._id,
                name: "TradeCredit",
                newdata: allbusiness,
                customtype: state.customtype,
              },
            });
          }
        }
      }
      if (allbusiness.type === "shippingDocuments") {
        if (
          allbusiness.shippingDocuments.forwardingDocument?.status ===
          "APPROVED" &&
          allbusiness.shippingDocuments.airWayBill?.status === "APPROVED" &&
          allbusiness.shippingDocuments.insurance?.status === "APPROVED" &&
          allbusiness.shippingDocuments.certificateOfOrigin?.status ===
          "APPROVED" &&
          allbusiness.shippingDocuments.packingList?.status === "APPROVED" &&
          allbusiness.shippingDocuments.inspectionCertificate?.status ===
          "APPROVED" &&
          allbusiness.shippingDocuments.exportAndImportDocument?.status ===
          "APPROVED"
        ) {
          navigate("/finance/review", {
            state: {
              ...allbusiness,
              customtype: state.customtype,
              ...state,
            },
          });
        } else {
          if (
            !allbusiness.shippingDocuments.airWayBill?.hasOwnProperty("status")
          ) {
            navigate("/finance/document", {
              state: {
                image: allbusiness?.shippingDocuments?.airWayBill?.url,
                type: "airWayBill",
                id: state._id,
                name: "TradeCredit",
                customtype: state.customtype,

                newdata: allbusiness,
              },
            });
          } else if (
            !allbusiness.shippingDocuments.certificateOfOrigin?.hasOwnProperty(
              "status"
            )
          ) {
            navigate("/finance/document", {
              state: {
                image: allbusiness?.shippingDocuments?.certificateOfOrigin?.url,
                type: "certificateOfOrigin",
                id: state._id,
                name: "TradeCredit",
                newdata: allbusiness,
                customtype: state.customtype,
              },
            });
          } else if (
            !allbusiness.shippingDocuments.exportAndImportDocument?.hasOwnProperty(
              "status"
            )
          ) {
            navigate("/finance/document", {
              state: {
                image:
                  allbusiness?.shippingDocuments?.exportAndImportDocument?.url,
                type: "exportAndImportDocument",
                id: state._id,
                name: "TradeCredit",
                newdata: allbusiness,
                customtype: state.customtype,
              },
            });
          } else if (
            !allbusiness.shippingDocuments.forwardingDocument?.hasOwnProperty(
              "status"
            )
          ) {
            navigate("/finance/document", {
              state: {
                image: allbusiness?.shippingDocuments?.forwardingDocument?.url,
                type: "forwardingDocument",
                id: state._id,
                name: "TradeCredit",
                newdata: allbusiness,
                customtype: state.customtype,
              },
            });
          } else if (
            !allbusiness.shippingDocuments.inspectionCertificate?.hasOwnProperty(
              "status"
            )
          ) {
            navigate("/finance/document", {
              state: {
                image:
                  allbusiness?.shippingDocuments?.inspectionCertificate?.url,
                type: "inspectionCertificate",
                id: state._id,
                name: "TradeCredit",
                newdata: allbusiness,
                customtype: state.customtype,
              },
            });
          } else if (
            !allbusiness.shippingDocuments.insurance?.hasOwnProperty("status")
          ) {
            navigate("/finance/document", {
              state: {
                image: allbusiness?.shippingDocuments?.insurance?.url,
                type: "vendorLetter",
                id: state._id,
                name: "TradeCredit",
                newdata: allbusiness,
                customtype: state.customtype,
              },
            });
          } else if (
            !allbusiness.shippingDocuments.packingList?.hasOwnProperty("status")
          ) {
            navigate("/finance/document", {
              state: {
                image: allbusiness?.shippingDocuments?.packingList?.url,
                type: "packingList",
                id: state._id,
                name: "TradeCredit",
                newdata: allbusiness,
                customtype: state.customtype,
              },
            });
          } else if (
            !allbusiness.shippingDocuments.packingList?.hasOwnProperty("status")
          ) {
            navigate("/finance/document", {
              state: {
                image: allbusiness?.shippingDocuments?.forwardingDocument?.url,
                type: "forwardingDocument",
                id: state._id,
                name: "TradeCredit",
                newdata: allbusiness,
                customtype: state.customtype,
              },
            });
          }
        }
      }
      if (allbusiness.type === "inventoryDocuments") {
        if (
          allbusiness.inventoryDocuments.agreement?.status === "APPROVED" &&
          allbusiness.inventoryDocuments.invoice?.status === "APPROVED"
        ) {
          navigate("/finance/review", {
            state: {
              ...allbusiness,
              customtype: state.customtype,
              ...state,
            },
          });
        } else {
          if (
            !allbusiness.inventoryDocuments.agreement?.hasOwnProperty("status")
          ) {
            navigate("/finance/document", {
              state: {
                image: allbusiness?.inventoryDocuments?.agreement?.url,
                type: "agreement",
                id: state._id,
                name: "TradeCredit",
                customtype: state.customtype,

                newdata: allbusiness,
              },
            });
          } else if (
            !allbusiness.inventoryDocuments.invoice?.hasOwnProperty("status")
          ) {
            navigate("/finance/document", {
              state: {
                image: allbusiness?.inventoryDocuments?.invoice?.url,
                type: "invoice",
                id: state._id,
                name: "TradeCredit",
                newdata: allbusiness,
                customtype: state.customtype,
              },
            });
          }
        }
      }
      if (allbusiness.type === "cashFlowSupport") {
        if (
          allbusiness.cashFlowSupport.agreement?.status === "APPROVED" &&
          allbusiness.cashFlowSupport.bankStatement?.status === "APPROVED" &&
          allbusiness.cashFlowSupport.managementAccount?.status === "APPROVED"
        ) {
          navigate("/finance/review", {
            state: {
              ...allbusiness,
              customtype: state.customtype,
              ...state,
            },
          });
        } else {
          if (
            !allbusiness.cashFlowSupport.agreement?.hasOwnProperty("status")
          ) {
            navigate("/finance/document", {
              state: {
                image: allbusiness?.cashFlowSupport?.agreement?.url,
                type: "agreement",
                id: state._id,
                name: "TradeCredit",
                customtype: state.customtype,

                newdata: allbusiness,
              },
            });
          } else if (
            !allbusiness.cashFlowSupport.managementAccount?.hasOwnProperty(
              "status"
            )
          ) {
            navigate("/finance/document", {
              state: {
                image: allbusiness?.cashFlowSupport?.managementAccount?.url,
                type: "managementAccount",
                id: state._id,
                name: "TradeCredit",
                newdata: allbusiness,
                customtype: state.customtype,
              },
            });
          } else if (
            !allbusiness.cashFlowSupport.bankStatement?.hasOwnProperty("status")
          ) {
            navigate("/finance/document", {
              state: {
                image: allbusiness?.cashFlowSupport?.bankStatement?.url,
                type: "bankStatement",
                id: state._id,
                name: "TradeCredit",
                newdata: allbusiness,
                customtype: state.customtype,
              },
            });
          }
        }
      }
    }
  };
  useEffect(() => {
    const fetchTransaction = async () => {
      if (!state?._id || !state?.customtype) return;
      setIsLoading(true);
      if (state.customtype === "Working Capital") {
        await axios
          .get(`/v1/admin/get-single-finance-trade-credit/${state._id}`)
          .then((res) => {
            //   console.log(res)
            setallbusiness(res.data.data);
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            setIsLoading(false);
          });
      } else if (state.customtype === "Credit Line") {
        await axios
          .get(`/v1/admin/get-single-finance-credit-line/${state._id}`)
          .then((res) => {
            // console.log(res);
            // setallbusiness(res.data.data);
            setallbusiness(res.data.data);
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            setIsLoading(false);
          });
      } else if (state.customtype === "Payments") {
        await axios
          .get(`/v1/admin/finance/pay/single/${state._id}`)
          .then((res) => {
            // console.log(res);
            setPaymentDetails(res?.data?.data);
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            setIsLoading(false);
          });
      } else {
        await axios
          .get(`/v1/admin/finance/single/${id}`)
          .then((res) => {
            setallbusiness(res.data.data);
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    };

    fetchTransaction();
  }, [state?.customtype, state?._id, id]);

  const filterwallet = businesswallet?.filter((item) =>
    item?.currency?.match(state?.currency)
  );

  const contractEmployer = paymentDetails?.pay?.purchaseOrder
    ? paymentDetails?.pay?.purchaseOrder?.inbound?.businessName
    : paymentDetails?.pay?.invoice?.inbound?.businessName;

  const startVerification = async (value) => {
    if (state.customtype === "Factoring") {
      const data = {
        status: value,
      };
      await axios
        .put(`/v1/admin/changeFinanceInvoiceStatus/${id}`, data)

        .then((res) => {
          if (value === "APPROVED") {
            axios.post(`/v1/admin/approveFinanceInvoice/${id}`, {
              amount:
                allbusiness.loanAmount === undefined
                  ? allbusiness.requestedAmount
                  : allbusiness.loanAmount,
              repaymentStructure: allbusiness.repaymentStructure,
              tenure: allbusiness.tenure,
            });
          }
          if (state.customtype === "Working Capital") {
            axios
              .get(`/v1/admin/get-single-finance-trade-credit/${state._id}`)
              .then((res) => {
                // console.log(res)
                // setallbusiness(res.data.data);
              })
              .catch((e) => {
                console.log(e);
              });
          } else if (state.customtype === "Credit Line") {
            axios
              .get(`/v1/admin/get-single-finance-credit-line/${state._id}`)
              .then((res) => {
                //  console.log(res)
                // setallbusiness(res.data.data);
              })
              .catch((e) => {
                console.log(e);
              });
          } else {
            axios
              .get(`/v1/admin/finance/single/${state._id}`)
              .then((res) => {
                // console.log(res)
                setallbusiness(res.data.data);
              })
              .catch((e) => {
                console.log(e);
              });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else if (state.customtype === "Working Capital") {
      const data = {
        status: value,
      };
      await axios
        .put(`/v1/admin/changeFinanceTradeCreditStatus/${id}`, data)
        .then(() => {
          if (value === "APPROVED") {
            axios.post(`/v1/admin/approveTradeCreditLoan/${id}`, {
              amount:
                allbusiness.loanAmount === undefined
                  ? allbusiness.requestedAmount
                  : allbusiness.loanAmount,
              repaymentStructure: allbusiness.repaymentStructure,
              tenure: allbusiness.tenure,
            });
          }
          axios
            .get(`/v1/admin/get-single-finance-trade-credit/${state._id}`)
            .then((res) => {
              // setallbusiness(res.data.data);
            });
        })
        .catch((e) => {
          console.log(e);
        });
    } else if (state.customtype === "Credit Line") {
      const data = {
        status: value,
      };
      await axios
        .put(`/v1/admin/changeFinanceCreditLineStatus/${id}`, data)
        .then((res) => {
          if (value === "APPROVED") {
            axios.post(`/v1/admin/approveCreditLineLoan/${id}`, {
              amount:
                allbusiness.loanAmount === undefined
                  ? allbusiness.requestedAmount
                  : allbusiness.loanAmount,
              repaymentStructure: allbusiness.repaymentStructure,
              tenure: allbusiness.tenure,
            });
          }
          axios
            .get(`/v1/admin/get-single-finance-credit-line/${state._id}`)
            .then((res) => {
              //console.log(res)
              // setallbusiness(res.data.data);
            });
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };
  const approveRequest = (id) => {
    if (state?.financeType === "payment_finance") {
      return navigate(`/finance/approve_request_new/${id}`, {
        state
      });
    }
    window.location.href = `/finance/approve_request/${id}`;
  };
  const disburseFunds = (id) => {
    window.location.href = `/finance/disburse_approved_funds/${id}`;
  };
  const RepayNow = async () => {
    setloader(true);
    await axios
      .post(`/v1/admin/loan/repay/${idloan}/${firstloan[0]?._id}`)
      .then((res) => {
        setsucess(true);
        setfail(false);
        setmessage(res.data.message);
        axios
          .get(
            `/v1/admin/loan/finance/${state._id}?financeType=${state.customtype === "Working Capital"
              ? "TradeCredit"
              : state.customtype === "Credit Line"
                ? "CreditLine"
                : "FinanceInvoice"
            }`
          )
          .then((res) => {
            setLoans(res.data.data?.loans);
          });
        setloader(false);
      })
      .catch((e) => {
        setsucess(false);
        setfail(true);
        setmessage(
          e.response?.data.message ? e.response?.data.message : "An error occur"
        );
        setloader(false);
      });
  };

  const isNotRequest = !!allbusiness?.financeType;
  const isCancelled =
    allbusiness?.status === "cancelled" ||
    allbusiness?.status === "draft" ||
    allbusiness?.status === "disbursed";
  const hasPoOrInvoice =
    !!allbusiness?.payableFinance?.purchaseOrders?.length ||
    !!allbusiness?.receivableFinance?.invoices?.length;

  const isPaymentPO =
    paymentDetails?.pay?.paymentType === "purchase_order" &&
      paymentDetails?.pay?.purchaseOrder &&
      Object.keys(paymentDetails?.pay?.purchaseOrder)?.length > 0
      ? [paymentDetails?.pay?.purchaseOrder]
      : [];
  const isPaymentInvoiceUrl =
    paymentDetails?.pay?.paymentType === "invoice" && paymentDetails?.pay?.url
      ? paymentDetails?.pay?.url
      : "";
  const isPaymentPOUrl =
    paymentDetails?.pay?.paymentType === "purchase_order" &&
      paymentDetails?.pay?.url
      ? paymentDetails?.pay?.url
      : "";
  const isPaymentTransactionUrl =
    paymentDetails?.pay?.paymentType === "transaction" &&
      paymentDetails?.pay?.url
      ? paymentDetails?.pay?.url
      : "";
  const isFreightTransactionUrl =
    paymentDetails?.pay?.paymentType === "freight_payment" &&
      paymentDetails?.pay?.url
      ? paymentDetails?.pay?.url
      : "";
  const isPaymentInvoice =
    paymentDetails?.pay?.paymentType === "invoice" &&
      paymentDetails?.pay?.invoice &&
      Object.keys(paymentDetails?.pay?.invoice).length > 0
      ? [paymentDetails.pay.invoice]
      : [];
  const isPoOrInvoice =
    allbusiness?.payableFinance?.financeCategory === "purchaseOrder" ||
    allbusiness?.financeType === "receivable_finance";

  const isFreightAndReverseable =
    allbusiness?.payableFinance?.financeCategory === "freightPayment" ||
    allbusiness?.payableFinance?.financeCategory === "transaction";

  console.log({ isFreightAndReverseable })

  const isPaymentFinance = state?.customtype === "Payment finance";
  function addInterest(amount, interestRate) {
    const totalAmount = amount * (1 + interestRate / 100);

    return Math.round(totalAmount * 100) / 100;
  }

  const paymentRef = {
    "swiftReference": 'Swift Reference',
    "contractAgreement": 'Contract Agreement'
  }
  const paymentFinanceDoc = allbusiness?.paymentFinance?.contractAgreement?.url ? allbusiness?.paymentFinance?.contractAgreement?.url : allbusiness?.paymentFinance?.swiftReference?.link?.url


  return (
    <>
      <div>
        <DeclineRequestModal
          show={showDeclineModal?.show}
          loader={loader}
          data={showDeclineModal?.data}
          setshow={setShowDeclineModal}
        />
        <CancelLoanModal
          show={showCancelLoanModal.show}
          loader={loader}
          data={showCancelLoanModal.data}
          setshow={setShowCancelLoanModal}
        />
        <AcceptLoanRequest id={id} loanId={state?.loans?.find(l => l.paymentStatus === 'UNPAID')?._id} show={showLoanModal} loader={loader} setshow={setShowLoanModal} />
        <AcceptPaymentModal show={showPayment} loader={loader} setshow={setShowPayment} />
        {showDisburseFunds && (
          <DisburseFundsModal
            show={showDisburseFunds}
            loader={loader}
            setshow={setShowDisburseFunds}
            data={allbusiness}
          />
        )}
        <RejectPaymentModal
          show={showRejectPayment}
          loader={loader}
          setshow={setShowRejectPayment}
        />
        {isLoading ? (
          <PageLoader />
        ) : (
          <>
              <OtherHeader title={"BACK TO FINANCE"} arrow={"keyboard_backspace"} />
            <div className="info-cl">
              {allbusiness.status === "SUBMITTED" && (
                <marquee
                  behavior=""
                  direction=""
                  style={{
                    color: "crimson",
                  }}
                >
                    FInance status must be in processing before you can start verifying the documents.
                </marquee>
              )}
              <div className="">
                <h4 className="p-0 m-0 text-3xl font-[450] text-[#344054]">
                  {!isNotRequest ? "Payment request" : "Finance details"}
                </h4>
              </div>
              <div className="flex gap-[30px] w-full">
                <div className="w-[420px] bg-white h-fit !rounded-[8px] overflow-hidden relative !p-0 !gap-0">
                  {fail && (
                    <div
                      className="success"
                      style={{
                        background: "#FCFCFD",
                        border: " 1px solid #D0D5DD",

                        boxSizing: "border-box",
                        zIndex: "9999",
                        width: "100%",
                      }}
                    >
                      <div className="lg-success">
                        <div
                          className="ech-lg-hm"
                          style={{
                            background: "#F9FAFB",
                          }}
                        >
                          <div
                            className="main-sucees"
                            style={{
                              color: "#344054",
                              textAlign: "center",
                              justifyContent: "center",
                              display: "flex",
                            }}
                          >
                            Access Denied
                          </div>
                          <span
                            style={{
                              color: "#344054",
                            }}
                          >
                            {message}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                  {paymentDetails.walletBalance && (
                    <div className="top_head_cl !p-6 items-center">
                        <div className="flex justify-between" style={{ width: "100%" }}>
                        <div className="flex flex-col">
                          <div className="">
                            {currencyPairCheck(state.currency)}

                            {state.customtype === "Payments" &&
                              parseFloat(state.amount).toLocaleString()}
                          </div>
                            <span className="capitalize">{paymentDetails?.pay?.paymentType}</span>
                        </div>
                        <p
                          style={{
                              color: statusColorsP[paymentDetails?.pay?.status] || "",
                          }}
                          className="capitalize"
                        >
                          {paymentDetails?.pay?.status}
                        </p>
                      </div>
                      <p
                        className="text-sm capitalize status_user"
                        style={{
                          color: statusColors[allbusiness?.status] || "",
                        }}
                      >
                          {statusDisplayMap[allbusiness?.status] || allbusiness?.status}
                      </p>
                    </div>
                  )}

                  {!paymentDetails?.walletBalance && (
                    <div className="top_head_cl !p-6 items-center">
                      <div className="!items-baseline ip_v_lg">
                        <div className="profile-d-icon size-[40px]">
                          {state?.business?.name?.slice(0, 2)}
                        </div>
                        <p className="name-avater-tag gap-[6px]">
                          <span className="font-medium text-2xl text-[#101828]">
                            {state?.business?.name}{" "}
                          </span>
                          <span className="business_name">
                              {state?.business?.user?.firstName} {state?.business?.user?.lastName}
                          </span>
                        </p>
                      </div>
                      <p
                        className="text-sm capitalize status_user"
                        style={{
                          color: statusColors[allbusiness?.status] || "",
                        }}
                      >
                          {statusDisplayMap[allbusiness?.status] || allbusiness?.status}
                      </p>
                    </div>
                  )}
                  {!isCancelled && (
                    <div
                      className={`flex items-center justify-start !p-6 !py-3 testing ${
                        paymentDetails?.pay?.status === "repaid" ||
                        paymentDetails?.pay?.status === "approved" ||
                        paymentDetails?.pay?.status === "cancelled" ||
                        paymentDetails?.pay?.status === "rejected"
                          ? "hidden"
                          : "border-y"
                      }`}
                    >
                      {allbusiness.status === "SUBMITTED" && (
                        <div
                          className="user_verify !pl-0"
                          style={{
                            width: "100%",
                            cursor: "pointer",
                            color: "#6F00FF",
                            fontWeight: "600",
                          }}
                          onClick={() => gotoDocuments()}
                        >
                          <img src={user} alt="" />
                          Review request
                        </div>
                      )}

                      {checkDocumentsStatus(state.customtype) === true &&
                      agreementDocument.length === 0 &&
                      allbusiness.status !== "REJECTED" ? (
                        <div
                          className="user_verify"
                          style={{
                            width: "100%",
                            cursor: "pointer",
                          }}
                          onClick={() => sendLenderDocument()}
                        >
                          {/**<img src={user} alt="" /> **/}
                          Send Lender's agreement
                        </div>
                      ) : (
                        ""
                      )}
                      <div>
                        {/* payment finance flow */}
                        {paymentDetails?.walletBalance && (
                          <div className="flex items-center gap-4">
                            {/* "approve loan request modal trigger" */}
                            <div>
                              {" "}
                              {paymentDetails.pay.status === "pending" && (
                                <div
                                  className="user_verify !pl-0"
                                  style={{
                                    width: "100%",
                                    cursor: "pointer",
                                    color: "#6F00FF",
                                  }}
                                  // onClick={() => startVerification("REJECTED")}
                                  onClick={() =>
                                    setShowPayment({
                                      show: true,
                                      data: allbusiness,
                                    })
                                  }
                                  // onClick={() => approveRequest(allbusiness._id)}
                                >
                                  Accept
                                </div>
                              )}
                            </div>
                            {/* "Decline request modal trigger" */}
                            <div>
                              {" "}
                              {paymentDetails.pay.status === "pending" && (
                                <div
                                  className="user_verify"
                                  style={{
                                    width: "100%",
                                    cursor: "pointer",
                                    color: "#383B56",
                                  }}
                                  // onClick={() => startVerification("REJECTED")}
                                  onClick={() =>
                                    setShowRejectPayment({
                                      show: true,
                                      data: allbusiness,
                                    })
                                  }
                                >
                                  Reject
                                </div>
                              )}
                            </div>

                            <div>
                              {allSigned() === true &&
                                allbusiness.status !== "COMPLETED" &&
                                allbusiness.status !== "APPROVED" &&
                                allbusiness.status !== "REJECTED" && (
                                  <button
                                    className="cursor-pointer w-full text-[#6F00FF] font-medium whitespace-nowrap text-base"
                                    onClick={() => {
                                      startVerification("APPROVED");
                                    }}
                                  >
                                    {/**<img src={user} alt="" />**/}
                                    Approve Requests
                                  </button>
                                )}
                            </div>
                          </div>
                        )}
                      </div>
                      <div>
                        {/* payable Loan finance flow  */}
                        {allbusiness?.financeType !== "payments" && (
                          <div className="flex gap-8">
                            {allbusiness.status === "pending" && (
                              <button
                                className="text-left cursor-pointer w-full text-[#6F00FF] font-medium whitespace-nowrap text-base"
                                // onClick={() => startVerification("REJECTED")}
                                onClick={() => {
                                  approveRequest(allbusiness._id);
                                }}
                              >
                                Approve Request
                              </button>
                            )}

                            {allbusiness.status === "pending" && (
                              <button
                                className="pl-0 whitespace-nowrap text-base font-medium cursor-pointer w-full text-[#383B56]"
                                onClick={() =>
                                  setShowDeclineModal({
                                    show: true,
                                    data: allbusiness,
                                  })
                                }
                              >
                                Decline Request
                              </button>
                            )}
                            {allbusiness.status === "approved" && (
                              <button
                                className="text-sm whitespace-nowrap font-[500] w-full cursour-pointer text-[#6F00FF] !pl-0"
                                // onClick={() => disburseFunds(allbusiness._id)}
                                onClick={() => {
                                  if (isPoOrInvoice && allbusiness?.employeeAproval === "pending") {
                                    Swal.fire({
                                      toast: true,
                                      position: "top-end",
                                      icon: "error",
                                      title: "Domiciliation agreement is still pending",
                                      showConfirmButton: false,
                                      timer: 3000,
                                      timerProgressBar: true,
                                    });
                                  } else {
                                    setShowDisburseFunds(true);
                                  }
                                }}
                              >
                                  Disburse funds
                                </button>
                              )}

                            {allbusiness.status === "approved" && (
                              <button
                                className="text-sm font-[500]"
                                style={{
                                  width: "100%",
                                  cursor: "pointer",
                                  color: "#383B56",
                                }}
                                // onClick={() => startVerification("REJECTED")}
                                onClick={() =>
                                  setShowCancelLoanModal({
                                    show: true,
                                    data: allbusiness,
                                  })
                                }
                              >
                                Cancel Loan{" "}
                              </button>
                              )}

                              {allbusiness.status === "disbursed" && (
                                <button
                                  className="text-sm whitespace-nowrap font-[500] w-full cursour-pointer text-[#6F00FF] !pl-0"
                                  onClick={() => {
                                    if (allbusiness.status === "disbursed") {
                                      Swal.fire({
                                        toast: true,
                                        position: "top-end",
                                        icon: "error",
                                        title: "A reminder has been sent",
                                        showConfirmButton: false,
                                        timer: 3000,
                                        timerProgressBar: true,
                                      });
                                    } else {
                                      setShowDisburseFunds(true);
                                    }
                                  }}
                                >
                                  Send reminder
                                </button>
                              )}

                            <div>
                              {allSigned() === true &&
                                allbusiness.status !== "COMPLETED" &&
                                allbusiness.status !== "APPROVED" &&
                                allbusiness.status !== "REJECTED" && (
                                  <button
                                    className="text-left cursor-pointer w-full text-[#6F00FF] font-medium whitespace-nowrap text-base"
                                    onClick={() => startVerification("APPROVED")}
                                  >
                                    {/**<img src={user} alt="" />**/}
                                    Approve Requests
                                  </button>
                                )}
                            </div>
                          </div>
                          )}


                      </div>

                      <div>
                        {/* receivable && inventory finance flow */}
                        {allbusiness?.financeType === "receivable_finance" ||
                        allbusiness?.financeType === "inventory_finance" ? (
                          <div className="flex items-center gap-10 -ml-2">
                            {/* "approve loan request modal trigger" */}
                            <div>
                              {" "}
                              {allbusiness.status === "testing" && (
                                <div
                                  className="flex items-center text-sm font-[500]"
                                  style={{
                                    width: "100%",
                                    cursor: "pointer",
                                    color: "#6F00FF",
                                  }}
                                  // onClick={() => startVerification("REJECTED")}
                                  onClick={() =>
                                    setShowPayment({
                                      show: true,
                                      data: allbusiness,
                                    })
                                  }
                                  // onClick={() => approveRequest(allbusiness._id)}
                                >
                                  Disburse funds
                                </div>
                              )}
                            </div>
                            {/* "Decline request modal trigger" */}
                            <div>
                              {" "}
                              {allbusiness.status === "testing" && (
                                <div
                                  className="flex items-center text-sm font-[500]"
                                  style={{
                                    width: "100%",
                                    cursor: "pointer",
                                    color: "#383B56",
                                  }}
                                  // onClick={() => startVerification("REJECTED")}
                                  onClick={() =>
                                    setShowRejectPayment({
                                      show: true,
                                      data: allbusiness,
                                    })
                                  }
                                >
                                  Cancel Loan
                                </div>
                              )}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      {allbusiness?.status === "APPROVED" &&
                      !allbusiness?.disbursementDate &&
                      allSigned() === true ? (
                        <>
                          <div
                            className="user_verify"
                            style={{
                              width: "100%",
                              color: "#98A2B3",
                              cursor: "pointer",
                              fontWeight: "600",
                            }}
                            onClick={() => {
                              navigate("/finance/fundrequest", {
                                state: {
                                  ...allbusiness,
                                  customtype: state.customtype,
                                },
                              });
                            }}
                          >
                            <img src={sendfunds} alt="" />
                            Disburse Payment
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                    )}
                    {(allbusiness?.financeType === "payment_finance" && allbusiness.status === "disbursed") && <div
                      className={`flex items-center justify-start !p-6 !py-3 testing border-y`}
                    >

                      <button
                        className="text-sm whitespace-nowrap font-[500] cursour-pointer text-[#6F00FF] !pl-0"
                        onClick={() => {
                          if (allbusiness.status === "disbursed") {
                            Swal.fire({
                              toast: true,
                              position: "top-end",
                              icon: "success",
                              title: "A reminder has been sent",
                              showConfirmButton: false,
                              timer: 3000,
                              timerProgressBar: true,
                            });
                          } else {
                            setShowDisburseFunds(true);
                          }
                        }}
                      >
                        Send reminder
                      </button>
                    </div>}

                  <div className="details-d_tl !p-6">
                    <div className="h-full">
                      <div
                        className="each_details_tl"
                        style={{
                          paddingBottom: "30px",
                        }}
                      >
                        {state.customtype === "Payments" && (
                          <>
                              <div className="mb-2 details_cl_tl">Request details</div>
                            <div className="each_main_tl">
                              <div className="each_d_lt"> Customer </div>
                                <p className="text-right">{paymentDetails?.pay?.business?.name}</p>
                            </div>
                            <div className="mt-4 each_main_tl">
                                <div className="each_d_lt"> Amount Requested </div>
                              <span className="d-lt-a">
                                {currencyPairCheck(state.currency)}

                                {state.customtype === "Payments" &&
                                  parseFloat(state.amount).toLocaleString()}
                              </span>
                            </div>
                          </>
                        )}
                        {state.customtype === "Payments" && (
                          <>
                            <div className="each_main_tl">
                              <div className="each_d_lt">Credit Amount</div>
                              <span className="d-lt-a">
                                {currencyPairCheck(state.currency)}
                                {state.customtype === "Payments" &&
                                    parseFloat(paymentDetails.walletBalance).toLocaleString()}
                              </span>
                            </div>
                            {contractEmployer && (
                              <div className="flex items-center justify-between mt-4">
                                  <div className="text-[14px] text-[#667085]">Contract employer</div>
                                  <div className="text-[14px] text-right">{contractEmployer}</div>
                              </div>
                            )}
                            <div className="flex items-start justify-between mt-4">
                                <div className="text-[14px] text-[#667085]">Payment account</div>
                              <div className="text-[16px] flex flex-col justify-end gap-2 text-right ">
                                <div className="text-[#344054]">
                                  {" "}
                                  {paymentDetails?.pay?.accountName}
                                </div>
                                <div className="text-[#6F739B]">
                                  {" "}
                                  {paymentDetails?.pay?.bankName}
                                </div>
                                <div className="text-[#6F739B]">
                                  {" "}
                                  {paymentDetails?.pay?.accountNumber}
                                </div>
                              </div>
                            </div>
                            <div className="flex justify-between mt-4">
                                <div className="text-[14px] text-[#667085]">Request date</div>
                              <div className="text-[16px]">
                                  {new Date(paymentDetails?.pay?.createdAt).toDateString()}
                              </div>
                            </div>
                          </>
                        )}

                          {state.customtype === "Working Capital" && allbusiness?.purchaseOrder && (
                            <>
                              <div className="each_main_tl">
                                <div className="each_d_lt">Contract Amount</div>
                                <span className="d-lt-a">
                                  {currencyPairCheck(state.currency)}
                                  {AmountCheck(state.contractAmount)}
                                </span>
                              </div>
                              <div className="each_main_tl">
                                <div className="each_d_lt">Contract Type</div>
                                <span className="d-lt-a">{state.contractType}</span>
                              </div>
                            </>
                          )}
                        {state.customtype === "Credit Line" && (
                          <>
                            <div className="each_main_tl">
                              <div className="each_d_lt">Request Title</div>
                                <span className="d-lt-a">{state.requestTitle} </span>
                            </div>
                          </>
                        )}

                        {state.customtype === "Factoring" && (
                          <div className="each_main_tl">
                            <div className="each_d_lt">Invoice Status</div>
                              <span className="d-lt-a">{allbusiness?.paymentStatus}</span>
                          </div>
                        )}

                        {state.customtype !== "Payments" && (
                          <>
                              {allbusiness?.status === "disbursed" && (
                              <div className="flex flex-col">
                                <div className="mb-4">Disbursal Details</div>
                                <div className="flex items-center justify-between">
                                    <div className="each_d_lt">Amount disbursed</div>
                                  <span className="d-lt-a">
                                    {currencyPairCheck(state.currency)}
                                    {AmountCheck(allbusiness?.loanAmount)}
                                  </span>
                                </div>
                                {allbusiness?.sourceOfFunds && (
                                   <div className="flex items-center justify-between mt-4">
                                    <div className="text-[14px] text-[#667085]">Source of Funds</div>
                                  <div className="text-[16px] font-[450]">
                                      {allbusiness?.sourceOfFunds}
                                  </div>
                                </div>
                                )}
                                <div className="flex items-center justify-between mt-4">
                                    <div className="text-[14px] text-[#667085]">Disbursal date</div>
                                  <div className="text-[16px] font-[450]">
                                      {new Date(allbusiness?.disbursementDate).toDateString()}
                                  </div>
                                </div>
                                  <div className="flex items-center justify-between mt-4">
                                    <div className="text-[14px] text-[#667085]">Repayment date</div>
                                    <div className="text-[16px] font-[450]">
                                      {new Date(allbusiness?.loans?.find(loan => loan?.paymentStatus === 'UNPAID')?.dueDate).toDateString()}
                                    </div>
                                  </div>
                              </div>
                            )}
                          </>
                        )}
                        {state.customtype !== "Payments" && (
                          <>
                              {!isPaymentFinance && (allbusiness?.status?.toLowerCase() !== "pending" && allbusiness?.status?.toLowerCase() !== "cancelled" && allbusiness?.status?.toLowerCase() !== "rejected") && (
                              <div className="flex flex-col">
                                <div className="mb-4">Offer Details</div>
                                <div className="flex items-center justify-between">
                                    <div className="each_d_lt">Offered amount </div>
                                  <span className="d-lt-a">
                                    {currencyPairCheck(state.currency)}
                                    {AmountCheck(allbusiness?.loanAmount)}
                                  </span>
                                </div>
                                <div className="flex items-center justify-between mt-4">
                                  <div className="text-[14px] text-[#667085]">
                                      Interest ({parseFloat(allbusiness?.interestRate) * 100}
                                    %)
                                  </div>
                                  <div className="text-[16px] font-[450]">
                                    {currencyPairCheck(state.currency)}
                                    {AmountCheck(allbusiness?.interestAmount)}
                                  </div>
                                </div>
                                  <div className="flex justify-between mt-4">
                                    <div className="text-[14px] text-[#667085]">Duration</div>
                                    <div className="text-[16px]">
                                      <div className="text-[#344054]">
                                        {allbusiness?.paymentFinance

                                          ?.duration
                                          ? allbusiness?.paymentFinance

                                            ?.duration > 1 ? allbusiness?.paymentFinance

                                              ?.duration + ' days' : allbusiness?.paymentFinance

                                            ?.duration + ' day'
                                          : allbusiness?.tenure
                                            ? allbusiness?.tenure > 1 ? allbusiness?.tenure + ' days' : allbusiness?.tenure + ' day'
                                            : "N/A"}
                                      </div>
                                    </div>
                                  </div>
                                <div className="flex items-start justify-between mt-4">
                                    <div className="text-[14px] text-[#667085]">Total to repay</div>
                                  <div className="text-[16px] flex flex-col justify-end gap-2 text-right ">
                                    <div className="text-[#344054]">
                                      {currencyPairCheck(state.currency)}
                                        {AmountCheck(allbusiness?.totalAmount) || "N/A"}
                                    </div>
                                  </div>
                                  </div>

                                  {allbusiness?.managementFeeDebitWalletType && <div className="flex items-start justify-between mt-4">
                                    <div className="text-[14px] text-[#667085]">Management fee</div>
                                    <div className="text-[16px] flex flex-col justify-end gap-2 text-right ">
                                      <div className="text-[#344054]">
                                        {ManagementFeeSource[allbusiness?.managementFeeDebitWalletType]}
                                      </div>
                                    </div>
                                  </div>}

                                <div className="flex justify-between mt-4">
                                    <div className="text-[14px] text-[#667085]">Repayment terms</div>
                                  <div className="text-[16px]">
                                    <div className="text-[#344054]">
                                      {allbusiness?.repaymentStructure
                                        ? allbusiness?.repaymentStructure
                                        : "N/A"}
                                    </div>
                                  </div>
                                </div>
                                <div className="flex items-center justify-between mt-4">
                                    <div className="text-[14px] text-[#667085]">Approval date</div>
                                  <div className="text-[14px]">
                                      {new Date(allbusiness?.createdAt).toDateString()}
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                          {state.customtype !== "Payments" && (
                            <>
                              {isPaymentFinance && (allbusiness?.status?.toLowerCase() !== "pending" && allbusiness?.status?.toLowerCase() !== "cancelled" && allbusiness?.status?.toLowerCase() !== "rejected") && (
                                <div className="flex flex-col">
                                  <div className="mb-4">Offer Details</div>
                                  <div className="flex items-center justify-between">
                                    <div className="each_d_lt">Offered amount </div>
                                    <span className="d-lt-a">
                                      {currencyPairCheck(state.currency)}
                                      {AmountCheck(allbusiness?.requestedAmount)}
                                    </span>
                                  </div>
                                  <div className="flex items-center justify-between mt-4">
                                    <div className="text-[14px] text-[#667085]">
                                      Prefered interest ({(allbusiness?.interestRate * 100)}
                                      %)
                                    </div>
                                    <div className="text-[16px] font-[450]">
                                      {(allbusiness?.interestRate * 100)}
                                      %
                                    </div>
                                  </div>
                                  <div className="flex items-start justify-between mt-4">
                                    <div className="text-[14px] text-[#667085]">Transfer fee</div>
                                    <div className="text-[16px] flex flex-col justify-end gap-2 text-right ">
                                      <div className="text-[#344054]">
                                        {currencyPairCheck(state.currency)}
                                        {AmountCheck(allbusiness?.paymentFinance?.transferFee)}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex items-start justify-between mt-4">
                                    <div className="text-[14px] text-[#667085]">Total to repay</div>
                                    <div className="text-[16px] flex flex-col justify-end gap-2 text-right ">
                                      <div className="text-[#344054]">
                                        {currencyPairCheck(state.currency)}
                                        {AmountCheck(allbusiness?.totalAmount)}
                                      </div>
                                    </div>
                                  </div>
                                  {allbusiness?.managementFeeDebitWalletType && <div className="flex items-start justify-between mt-4">
                                    <div className="text-[14px] text-[#667085]">Management fee</div>
                                    <div className="text-[16px] flex flex-col justify-end gap-2 text-right ">
                                      <div className="text-[#344054]">
                                        {ManagementFeeSource[allbusiness?.managementFeeDebitWalletType]}
                                      </div>
                                    </div>
                                  </div>}
                                  <div className="flex justify-between mt-4">
                                    <div className="text-[14px] text-[#667085]">Duration</div>
                                    <div className="text-[16px]">
                                      <div className="text-[#344054]">
                                        {allbusiness?.tenure
                                          ? allbusiness?.tenure > 1 ? allbusiness?.tenure + ' days' : allbusiness?.tenure + ' day'
                                          : "N/A"}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex justify-between mt-4">
                                    <div className="text-[14px] text-[#667085]">Repayment terms</div>
                                    <div className="text-[16px]">
                                      <div className="text-[#344054]">
                                        {allbusiness?.repaymentStructure
                                          ? allbusiness?.repaymentStructure
                                          : "N/A"}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex items-center justify-between mt-4">
                                    <div className="text-[14px] text-[#667085]">Approval date</div>
                                    <div className="text-[14px]">
                                      {new Date(allbusiness?.createdAt).toDateString()}
                                    </div>
                                  </div>
                                </div>
                              )}
                              <div className="flex flex-col">
                                <div className="mb-4">Request Details</div>

                                <div className="flex items-center justify-between">
                                  <div className="each_d_lt">Request amount </div>
                                  <span className="d-lt-a">
                                    {currencyPairCheck(state.currency)}
                                    {AmountCheck(allbusiness?.requestedAmount)}
                                  </span>
                                </div>
                                <div className="flex items-center justify-between mt-4">
                                  <div className="text-[14px] text-[#667085]">Request date</div>
                                  <div className="text-[14px] w-1/2 text-right">
                                    {allbusiness?.paymentFinance?.createdAt ? new Date(allbusiness?.paymentFinance?.createdAt)?.toDateString() : new Date(allbusiness?.createdAt)?.toDateString()}
                                  </div>
                                </div>
                                {allbusiness?.paymentFinance?.purposeOfFund && <div className="flex items-center justify-between mt-4">
                                  <div className="text-[14px] text-[#667085]">Purpose of funds</div>
                                  <div className="text-[14px] w-1/2 text-right">
                                    {allbusiness?.paymentFinance?.purposeOfFund || "N/A"}
                                  </div>
                                </div>}
                                {isPaymentFinance && (
                                  <div className="flex flex-col">
                                    <div className="flex justify-between mt-4">
                                      <div className="text-[14px] text-[#667085]">Duration</div>
                                      <div className="text-[16px]">
                                        <div className="text-[#344054]">
                                          {allbusiness?.paymentFinance

                                            ?.duration
                                            ? allbusiness?.paymentFinance

                                              ?.duration > 1 ? allbusiness?.paymentFinance

                                                ?.duration + ' days' : allbusiness?.paymentFinance

                                                  ?.duration + ' day'
                                            : allbusiness?.tenure
                                              ? allbusiness?.tenure > 1 ? allbusiness?.tenure + ' days' : allbusiness?.tenure + ' day'
                                              : "N/A"}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex justify-between mt-4">
                                      <div className="text-[14px] text-[#667085]">Prefered interest</div>
                                      <div className="text-[16px]">
                                        <div className="text-[#344054]">
                                          {allbusiness?.paymentFinance?.interestRate} %
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex justify-between mt-4">
                                      <div className="text-[14px] text-[#667085]">Payment reference</div>
                                      <div className="text-[16px]">
                                        <div className="text-[#344054]">
                                          {paymentRef[allbusiness?.paymentFinance?.paymentReferenceType] || "N/A"}
                                        </div>
                                      </div>
                                    </div>
                                    {(allbusiness?.paymentFinance?.paymentReferenceType !== 'contractAgreement' && allbusiness?.paymentFinance?.swiftReference
                                      ?.swiftType === 'UETR') && <div className="flex justify-between mt-4">
                                        <div className="text-[16px] text-[#667085]">UETR</div>
                                        <div className="text-[14px] w-1/2 text-right">
                                          <p className="text-[#344054] text-wrap whitspace-break">
                                            {allbusiness?.paymentFinance?.swiftReference?.UETR || allbusiness?.paymentFinance?.swiftReference?.uetr || "N/A"}
                                          </p>
                                      </div>
                                    </div>}
                                    {(allbusiness?.paymentFinance?.paymentReferenceType !== 'contractAgreement' && allbusiness?.paymentFinance?.swiftReference
                                      ?.swiftType !== 'UETR') && <div className="flex justify-between mt-4">
                                        <div className="text-[16px] text-[#667085]">Swift Type</div>
                                        <div className="text-[14px] w-1/2 text-right">
                                          <p className="text-[#344054] text-wrap whitspace-break">
                                            {allbusiness?.paymentFinance?.swiftReference?.swiftType || "N/A"}
                                          </p>
                                        </div>
                                      </div>}
                                    <div className="flex justify-between mt-4">
                                      <div className="text-[14px] text-[#667085]">Loan type</div>
                                      <div className="text-[14px] text-right capitalize">
                                        <p className="">{financeTypes[allbusiness?.financeType]}</p>
                                        <span className="text-xs text-right capitalize">
                                          {allbusiness?.financeType === "payment_finance" ? ManagementFeeSource[allbusiness?.managementFeeDebitWalletType] : allbusiness?.financeType === "payable_finance"
                                            ? financeOptions?.find(finance => finance?.value === allbusiness?.payableFinance?.financeCategory)?.label
                                            : allbusiness?.financeType === "receivable_finance"
                                              ? "Invoice"
                                              : allbusiness?.inventoryFinance?.financeCategory}
                                        </span>
                                      </div>
                                    </div>
                                    <div className="flex mt-4 space-y-2 flex-col">
                                      {allbusiness?.disburseMethod !== 'CreditWallet' && <div className="">Recipient Details</div>}
                                      {allbusiness?.paymentFinance?.paymentDestination?.address && <div className="flex items-center justify-between">
                                        <div className="each_d_lt">Wallet address</div>
                                        <span className="d-lt-a text-wrap">
                                          {allbusiness?.paymentFinance?.paymentDestination?.address ? (
                                            <>
                                              {allbusiness?.paymentFinance?.paymentDestination?.address.slice(0, Math.ceil(allbusiness.paymentFinance.paymentDestination.address.length / 2))}
                                              <br />
                                              {allbusiness?.paymentFinance?.paymentDestination?.address.slice(Math.ceil(allbusiness.paymentFinance.paymentDestination.address.length / 2))}
                                            </>
                                          ) : null}
                                        </span>
                                      </div>}
                                      {allbusiness?.paymentFinance?.paymentDestination?.network && <div className="flex items-center justify-between">
                                        <div className="each_d_lt">Network</div>
                                        <span className="d-lt-a text-wrap">
                                          {allbusiness?.paymentFinance?.paymentDestination?.network}
                                        </span>
                                      </div>}
                                    </div>

                                  </div>
                                )}
                                {allbusiness?.financeType !== 'payment_finance' && (
                                  <div className="flex items-center justify-between mt-4">
                                    <div className="text-[14px] text-[#667085]">Loan type</div>
                                <div className="text-[14px] text-right capitalize">
                                      <p className="">{financeTypes[allbusiness?.financeType]}</p>
                                  <span className="text-xs text-right capitalize">
                                        {allbusiness?.financeType === "payment_finance" ? ManagementFeeSource[allbusiness?.managementFeeDebitWalletType] : allbusiness?.financeType === "payable_finance"
                                          ? financeOptions?.find(finance => finance?.value === allbusiness?.payableFinance?.financeCategory)?.label
                                          : allbusiness?.financeType === "receivable_finance"
                                            ? "Invoice"
                                            : allbusiness?.inventoryFinance?.financeCategory}
                                  </span>
                                </div>
                              </div>
                            )}
                            {state.customtype === "Receivables finance" && (
                              <div>
                                    {allbusiness?.receivableFinance?.invoices?.length > 0 && (
                                  <>
                                    <div
                                      className="flex items-start justify-between mt-4 cursor-pointer"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setShowPreview((p) => !p);
                                      }}
                                    >
                                          <div className="text-[14px] text-[#667085]">Invoice</div>

                                          <div className="flex items-center gap-1 text-[#5E01D6]">
                                            <span> invoice</span>{" "}
                                            <img src={exportSvg} alt="export svg" />
                                          </div>
                                        </div>
                                        <>
                                          <Preview
                                            currency={allbusiness?.currency}
                                            addTax={(
                                              allbusiness?.receivableFinance?.purchaseOrders?.[0]
                                                ?.taxAmount || 0
                                            ).toFixed(2)}
                                            dueDate={
                                              allbusiness?.receivableFinance?.purchaseOrders?.[0]
                                                ?.deliveryDate
                                                ? dayjs(
                                                  allbusiness?.receivableFinance?.purchaseOrders?.[0]
                                                    ?.deliveryDate,
                                              ).format("MMM D, YYYY")
                                                : "No due date"
                                            }
                                            note={
                                              allbusiness?.receivableFinance?.purchaseOrders?.[0]?.note
                                            }
                                            orderItems={
                                              allbusiness?.receivableFinance?.purchaseOrders?.[0]
                                                ?.orderItems
                                            }
                                            paymentTerms={
                                              allbusiness?.receivableFinance?.purchaseOrders?.[0]
                                                ?.paymentTerms
                                            }
                                            splitTerm="0"
                                            subtotal={(
                                              allbusiness?.receivableFinance?.purchaseOrders?.[0]
                                                ?.totalAmount || 0
                                            ).toFixed(2)}
                                            supplier={{
                                              name: allbusiness?.receivableFinance?.purchaseOrders?.[0]
                                                ?.inbound?.businessName,
                                              personalName:
                                                allbusiness?.receivableFinance?.purchaseOrders?.[0]
                                                  ?.inbound?.email,
                                            }}
                                            surCharge={(
                                              allbusiness?.receivableFinance?.purchaseOrders?.[0]
                                                ?.surCharge || 0
                                            ).toFixed(2)}
                                            total={(
                                              allbusiness?.receivableFinance?.purchaseOrders?.[0]
                                                ?.totalAmount || 0
                                            ).toFixed(2)}
                                            user={{
                                              bizName:
                                                allbusiness?.receivableFinance?.purchaseOrders?.[0]
                                                  ?.outbound?.businessName,
                                              bizImg: "",
                                              fullName:
                                                allbusiness?.receivableFinance?.purchaseOrders?.[0]
                                                  ?.outbound?.email,
                                            }}
                                            preview={showPreview}
                                            onClose={() => setShowPreview((p) => !p)}
                                          />
                                        </>
                                      </>
                                    )}
                                  </div>
                                )}

                            {state.customtype === "Payables finance" &&
                                  allbusiness?.payableFinance?.purchaseOrders?.length ? (
                              <>
                                <div
                                  className="flex items-start justify-between mt-4 cursor-pointer"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setShowPreview(true);
                                  }}
                                >
                                        <div className="text-[14px] text-[#667085]">Purchase Order</div>

                                  <div className="flex items-center gap-1 text-[#5E01D6]">
                                    <span>Purchase order</span>{" "}
                                    <img src={exportSvg} alt="export svg" />
                                  </div>
                                </div>

                                <>
                                  <Preview
                                    currency={allbusiness?.currency}
                                    addTax={(
                                      allbusiness?.payableFinance?.purchaseOrders[0]?.taxAmount || 0
                                    ).toFixed(2)}
                                    dueDate={
                                      allbusiness?.payableFinance?.purchaseOrders[0]?.deliveryDate
                                        ? dayjs(
                                          allbusiness?.payableFinance?.purchaseOrders[0]
                                            ?.deliveryDate,
                                          ).format("MMM D, YYYY")
                                        : "No due date"
                                    }
                                          note={allbusiness?.payableFinance?.purchaseOrders[0]?.note}
                                    orderItems={
                                      allbusiness?.payableFinance?.purchaseOrders[0]?.orderItems
                                    }
                                    paymentTerms={
                                      allbusiness?.payableFinance?.purchaseOrders[0]?.paymentTerms
                                    }
                                    splitTerm="0"
                                    subtotal={(
                                      allbusiness?.payableFinance?.purchaseOrders[0]?.totalAmount ||
                                      0
                                    ).toFixed(2)}
                                    supplier={{
                                      name: allbusiness?.payableFinance?.purchaseOrders[0]?.inbound
                                        ?.businessName,
                                      personalName:
                                        allbusiness?.payableFinance?.purchaseOrders[0]?.inbound
                                          ?.email,
                                    }}
                                    surCharge={(
                                      allbusiness?.payableFinance?.purchaseOrders[0]?.surCharge || 0
                                    ).toFixed(2)}
                                    total={(
                                      allbusiness?.payableFinance?.purchaseOrders[0]?.totalAmount ||
                                      0
                                    ).toFixed(2)}
                                    user={{
                                      bizName:
                                        allbusiness?.payableFinance?.purchaseOrders[0]?.outbound
                                          ?.businessName,
                                      bizImg: "",
                                      fullName:
                                        allbusiness?.payableFinance?.purchaseOrders[0]?.outbound
                                          ?.email,
                                    }}
                                    preview={showPreview}
                                    onClose={() => setShowPreview(false)}
                                  />
                                </>
                              </>
                            ) : null}
                                {((!isFreightAndReverseable && isPoOrInvoice && hasPoOrInvoice) &&
                              allbusiness?.status === "approved") && (
                              <div className="flex justify-between mt-4">
                                <div className="text-[14px] text-[#667085]">
                                  Domicilliation agreement
                                    </div>
                                <div className="">
                                  <p className="text-[#344054] text-base capitalize">
                                    {allbusiness?.employeeAproval
                                      ? allbusiness?.employeeAproval
                                      : "N/A"}
                                  </p>
                                </div>
                              </div>
                            )}
                            {managementFinanceOptions.find(
                              (item) => item.value === allbusiness?.managementType,
                            ) && (
                              <div className="flex items-center justify-between mt-4">
                                    <div className="text-[14px] text-[#667085]">Management fee</div>
                                <div className="text-[14px]">
                                  <p>
                                        {ManagementFeeSource[allbusiness?.managementFeeDebitWalletType]}
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                            </>
                        )}

                        {!paymentDetails && (
                          <div className="each_main_tl">
                            <div className="each_d_lt">Management Fee (1%)</div>
                            <span className="d-lt-a">
                              {currencyPairCheck(state.currency)}

                                {AmountCheck(0.01 * parseFloat(state?.requestedAmount))}
                            </span>
                          </div>
                        )}

                        {state.customtype === "Working Capital" ? (
                          <div className="each_main_tl">
                            <div className="each_d_lt">
                                Interest ({parseFloat(allbusiness?.interestRate) * 100}%)
                            </div>
                            <span className="d-lt-a">
                              {currencyPairCheck(state.currency)}
                              {parseFloat(
                                allbusiness?.interestRate * allbusiness?.requestedAmount,
                              ).toLocaleString()}
                            </span>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      {state.customtype === "Working Capital" && (
                        <div className="each_main_tl">
                          <div className="each_d_lt">Type</div>
                          <span className="d-lt-a">
                            {allbusiness?.type === "purchaseOrder"
                              ? "Purchase Order"
                              : allbusiness.type === "shippingDocuments"
                                  ? "Shipping Documents"
                                  : allbusiness.type === "inventoryDocuments"
                                    ? "Inventory Documents"
                                    : "CashFlow Support"}
                          </span>
                        </div>
                      )}
                      {state.customtype === "Credit Line" && (
                        <>
                          <div className="details_cl_tl">Other Details</div>

                            <div className="each_details_tl" style={{ paddingBottom: "30px" }}>
                            <div className="each_main_tl">
                                <div className="each_d_lt">Annual Sales Revenue</div>
                              <span className="d-lt-a">
                                {currencyPairCheck(state.currency)}
                                  {parseFloat(state.annualRevenue).toLocaleString()}
                              </span>
                            </div>
                            <div className="each_main_tl">
                              <div className="each_d_lt">Annual Turnover</div>
                              <span className="d-lt-a">
                                {currencyPairCheck(state.currency)}
                                  {parseFloat(state.annualTurnOver).toLocaleString()}
                              </span>
                            </div>
                          </div>
                        </>
                      )}
                      {state.customtype === "Factoring" && (
                        <>
                          <div
                            className="details_cl_tl"
                            style={{
                              textTransform: "capitalize",
                            }}
                          >
                            {allbusiness?.userType} Details
                          </div>

                            <div className="each_details_tl" style={{ paddingBottom: "30px" }}>
                            <div className="each_main_tl">
                              <div className="each_d_lt">Firstname</div>
                                <span className="d-lt-a">{allbusiness?.invoice?.firstName} </span>
                            </div>
                            <div className="each_main_tl">
                              <div className="each_d_lt">Email</div>
                                <span className="d-lt-a">{allbusiness?.invoice?.email}</span>
                            </div>
                            <div className="each_main_tl">
                              <div className="each_d_lt">Phone Number</div>
                                <span className="d-lt-a">{allbusiness?.invoice?.phoneNumber}</span>
                            </div>
                            <div className="each_main_tl">
                              <div className="each_d_lt">User Type</div>
                                <span className="d-lt-a">{allbusiness?.invoice?.userType}</span>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="w-[calc(100% - 420px)] flex-1 !rounded-[8px]">
                  <ul className="tp-head-list">
                      {(isPaymentFinance && allbusiness?.repayments?.length) ? <li
                        onClick={() => settab("repayment")}
                        style={{
                          borderBottom: tab === "repayment" ? "3px solid #6F00FF" : "",
                        }}
                      >
                        Repayments
                      </li> : null}
                    <li
                      onClick={() => settab("kyc")}
                      style={{
                        borderBottom: tab === "kyc" ? "3px solid #6F00FF" : "",
                      }}
                    >
                      Document
                    </li>
                    {state?.customtype === "Working Capital" && (
                      <li
                        onClick={() => settab("bank")}
                        style={{
                          borderBottom: tab === "bank" ? "3px solid #6F00FF" : "",
                        }}
                      >
                        {allbusiness?.userType ? allbusiness?.userType : ""}
                      </li>
                    )}
                    {state?.customtype === "Factoring" && (
                      <li
                        onClick={() => settab("bank")}
                        style={{
                          borderBottom: tab === "bank" ? "3px solid #6F00FF" : "",
                        }}
                      >
                        Invoice Details
                      </li>
                    )}
                  </ul>
                  <div
                    className="main_tp_lig"
                    style={{
                      minHeight: "600px !important",
                    }}
                  >
                    {!isNotRequest ? (
                      <div className="flex flex-col items-start justify-start h-full">
                        {isPaymentPO.length ? (
                          <>
                            <div className="flex flex-col left-ttl-c">
                              <span className="typ_lg_vg font-[500] text-[#667085] text-[14px]">
                                Purchase order
                              </span>
                              <div className="flex items-center justify-between px-[16px] py-[12px] bg-[#f9fafb] rounded-md cursor-point">
                                <div className="flex items-center gap-[12px]">
                                  <div className="w-[40px] h-[40px] bg-[#EEF4FF] rounded-[8px] flex items-center justify-center">
                                    <img src={document} alt="" />
                                  </div>
                                  <div>Purchase order</div>
                                </div>
                                <div className="flex items-center gap-[12px]">
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setShowPreview(true);
                                    }}
                                    className="bg-[#fff] rounded-[6px] px-[12px] py-[6px] text-[14px] font-[500] cursor-pointer text-[#344054]"
                                  >
                                    Preview
                                  </button>

                                  {/* <ChevronRight color="#667085" /> */}
                                </div>
                              </div>
                            </div>
                            <>
                              <Preview
                                currency={allbusiness?.currency}
                                  addTax={(isPaymentPO?.[0]?.taxAmount || 0).toFixed(2)}
                                dueDate={
                                  isPaymentPO?.[0]?.deliveryDate
                                    ? dayjs(isPaymentPO?.[0]?.deliveryDate).format("MMM D, YYYY")
                                    : "No due date"
                                }
                                note={isPaymentPO?.[0]?.note}
                                orderItems={isPaymentPO?.[0]?.orderItems}
                                paymentTerms={isPaymentPO?.[0]?.paymentTerms}
                                splitTerm="0"
                                  subtotal={(isPaymentPO?.[0]?.totalAmount || 0).toFixed(2)}
                                supplier={{
                                  name: isPaymentPO?.[0]?.inbound?.businessName,
                                  personalName: isPaymentPO?.[0]?.inbound?.email,
                                }}
                                  surCharge={(isPaymentPO?.[0]?.surCharge || 0).toFixed(2)}
                                  total={(isPaymentPO?.[0]?.totalAmount || 0).toFixed(2)}
                                user={{
                                  bizName: isPaymentPO?.[0]?.outbound?.businessName,
                                  bizImg: "",
                                  fullName: isPaymentPO?.[0]?.outbound?.email,
                                }}
                                preview={showPreview}
                                onClose={() => setShowPreview((p) => !p)}
                              />
                            </>
                          </>
                        ) : null}
                        {isPaymentInvoice.length ? (
                          <>
                            <div
                              className="left-ttl-c"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <span
                                className="typ_lg_vg"
                                style={{
                                  fontWeight: "500",
                                  color: "#667085",
                                  fontSize: "14px",
                                }}
                              >
                                Invoice order
                              </span>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  padding: "12px 16px",
                                  backgroundColor: "#F9FAFB",
                                  borderRadius: "8px",
                                  cursor: "pointer",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      backgroundColor: "#EEF4FF",
                                      borderRadius: "8px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <img src={document} alt="" />
                                  </div>
                                  <div>Invoice order</div>
                                  <></>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                  }}
                                >
                                  <button
                                      onClick={() => setShowPreview((prev) => !prev)}
                                    style={{
                                      backgroundColor: "#fff",
                                      // border: "1px solid #D0D5DD",
                                      borderRadius: "6px",
                                      padding: "6px 12px",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                      cursor: "pointer",
                                      color: "#344054",
                                    }}
                                  >
                                    Invoice
                                  </button>

                                  {/* <ChevronRight color="#667085" /> */}
                                </div>
                              </div>
                            </div>
                            <>
                              <Preview
                                currency={allbusiness?.currency}
                                  addTax={(isPaymentInvoice?.[0]?.taxAmount || 0).toFixed(2)}
                                dueDate={
                                  isPaymentInvoice?.[0]?.deliveryDate
                                    ? dayjs(isPaymentInvoice?.[0]?.deliveryDate).format(
                                      "MMM D, YYYY",
                                    )
                                    : "No due date"
                                }
                                note={isPaymentInvoice?.[0]?.note}
                                orderItems={isPaymentInvoice?.[0]?.orderItems}
                                  paymentTerms={isPaymentInvoice?.[0]?.paymentTerms}
                                splitTerm="0"
                                  subtotal={(isPaymentInvoice?.[0]?.totalAmount || 0).toFixed(2)}
                                supplier={{
                                  name: isPaymentInvoice?.[0]?.inbound?.businessName,
                                  personalName: isPaymentInvoice?.[0]?.inbound?.email,
                                }}
                                  surCharge={(isPaymentInvoice?.[0]?.surCharge || 0).toFixed(2)}
                                  total={(isPaymentInvoice?.[0]?.totalAmount || 0).toFixed(2)}
                                user={{
                                  bizName: isPaymentInvoice?.[0]?.outbound?.businessName,
                                  bizImg: "",
                                  fullName: isPaymentInvoice?.[0]?.outbound?.email,
                                }}
                                preview={showPreview}
                                onClose={() => setShowPreview((p) => !p)}
                              />
                            </>
                          </>
                        ) : null}
                        {isPaymentInvoiceUrl.length ? (
                          <div className="flex flex-col w-full gap-10">
                            <div
                              className="left-ttl-c"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <span
                                className="typ_lg_vg"
                                style={{
                                  fontWeight: "500",
                                  color: "#667085",
                                  fontSize: "14px",
                                }}
                              >
                                Invoice Document
                              </span>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  padding: "12px 16px",
                                  backgroundColor: "#F9FAFB",
                                  borderRadius: "8px",
                                  cursor: "pointer",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                  }}
                                  onClick={() => {
                                    const url = isPaymentInvoiceUrl;
                                    if (url) {
                                      window.open(url, "_blank");
                                    }
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: "15px",
                                      fontWeight: "500",
                                      color: "#101828",
                                      margin: 0,
                                    }}
                                  >
                                      <FileDisplay url={isPaymentInvoiceUrl} maxWidth="200px" />
                                  </p>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: "15px",
                                      fontWeight: "600",
                                      color: "#101828",
                                      margin: 0,
                                    }}
                                  ></p>
                                  <ChevronRight color="#667085" />
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}

                        {isPaymentPOUrl.length ? (
                          <div className="flex flex-col w-full gap-10">
                            <div
                              className="left-ttl-c"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <span
                                className="typ_lg_vg"
                                style={{
                                  fontWeight: "500",
                                  color: "#667085",
                                  fontSize: "14px",
                                }}
                              >
                                Purchase Document
                              </span>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  padding: "12px 16px",
                                  backgroundColor: "#F9FAFB",
                                  borderRadius: "8px",
                                  cursor: "pointer",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                  }}
                                  onClick={() => {
                                    const url = isPaymentPOUrl;
                                    if (url) {
                                      window.open(url, "_blank");
                                    }
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: "15px",
                                      fontWeight: "500",
                                      color: "#101828",
                                      margin: 0,
                                    }}
                                  >
                                      <FileDisplay url={isPaymentPOUrl} maxWidth="200px" />
                                  </p>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: "15px",
                                      fontWeight: "600",
                                      color: "#101828",
                                      margin: 0,
                                    }}
                                  ></p>
                                  <ChevronRight color="#667085" />
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}

                        {isPaymentTransactionUrl.length ? (
                          <div className="flex flex-col w-full gap-10">
                            <div
                              className="left-ttl-c"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <span
                                className="typ_lg_vg"
                                style={{
                                  fontWeight: "500",
                                  color: "#667085",
                                  fontSize: "14px",
                                }}
                              >
                                Transaction Document
                              </span>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  padding: "12px 16px",
                                  backgroundColor: "#F9FAFB",
                                  borderRadius: "8px",
                                  cursor: "pointer",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                  }}
                                  onClick={() => {
                                    const url = isPaymentTransactionUrl;
                                    if (url) {
                                      window.open(url, "_blank");
                                    }
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: "15px",
                                      fontWeight: "500",
                                      color: "#101828",
                                      margin: 0,
                                    }}
                                  >
                                      <FileDisplay url={isPaymentTransactionUrl} maxWidth="200px" />
                                  </p>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: "15px",
                                      fontWeight: "600",
                                      color: "#101828",
                                      margin: 0,
                                    }}
                                  ></p>
                                  <ChevronRight color="#667085" />
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}

                        {isFreightTransactionUrl.length ? (
                          <div className="flex flex-col w-full gap-10">
                            <div
                              className="left-ttl-c"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <span
                                className="typ_lg_vg"
                                style={{
                                  fontWeight: "500",
                                  color: "#667085",
                                  fontSize: "14px",
                                }}
                              >
                                Freight Document
                              </span>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  padding: "12px 16px",
                                  backgroundColor: "#F9FAFB",
                                  borderRadius: "8px",
                                  cursor: "pointer",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                  }}
                                  onClick={() => {
                                    const url = isFreightTransactionUrl;
                                    if (url) {
                                      window.open(url, "_blank");
                                    }
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: "15px",
                                      fontWeight: "500",
                                      color: "#101828",
                                      margin: 0,
                                    }}
                                  >
                                      <FileDisplay url={isFreightTransactionUrl} maxWidth="200px" />
                                  </p>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: "15px",
                                      fontWeight: "600",
                                      color: "#101828",
                                      margin: 0,
                                    }}
                                  ></p>
                                  <ChevronRight color="#667085" />
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}

                        {!isPaymentPO.length &&
                        !isPaymentInvoiceUrl.length &&
                        !isPaymentTransactionUrl.length &&
                        !isFreightTransactionUrl.length &&
                        !isPaymentPOUrl.length &&
                        !isPaymentInvoice.length ? (
                          <div className="flex flex-col items-center justify-center w-full h-full">
                                <img src={empty || "/placeholder.svg"} alt="empty icon" />
                            <p className="text-base font-semibold text-center">
                              No documents attached <br /> to this request
                            </p>
                          </div>
                        ) : null}
                      </div>
                    ) : (
                          <>
                            {tab === "repayment" && (
                              <>
                                {allbusiness?.repayments?.map((loan, index) => {
                                  console.log({ loan })
                                  return (
                                    <div
                                  className="prof_ad_rf"
                                      key={index}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    navigate("/finance/document", {
                                      state: {
                                        image: paymentFinanceDoc ?? paymentFinanceDoc?.url,
                                        type: "payment_finance",
                                        id: state?._id,
                                        name: "Payment finance",
                                        seg: 'single',
                                        loanId: loan?._id,
                                        selectedIndex: index,
                                        ...allbusiness
                                      },
                                    });
                                  }}
                                >
                                  <div className="each_sec_lg_vg">
                                    <div className="lg-md-lf-glv">
                                      {currencyPairCheck(allbusiness?.currency)}  {formatMoney(allbusiness?.totalAmount)}
                                    </div>

                                    <div className="flex gap-1 capitalize text-yellow-600">
                                          {loan?.status === 'REJECT' ? 'REJECTED' : loan?.status}
                                      <ChevronRight />
                                    </div>
                                  </div>
                                    </div>
                                  )
                                })}
                              </>
                            )}
                        {tab === "kyc" && (
                          <>
                            {state.customtype === "Factoring" && (
                              <>
                                <div
                                  className="prof_ad_rf"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    if (allbusiness?.invoiceDocument) {
                                      navigate("/finance/document", {
                                        state: {
                                          image: allbusiness?.invoiceDocument?.url,
                                          type: "invoice",
                                          id: state._id,
                                          name: "Invoice",
                                        },
                                      });
                                    }
                                  }}
                                >
                                  <div className="left-ttl-c">
                                    <span className="typ_lg_vg">Invoice</span>
                                  </div>
                                  <div className="each_sec_lg_vg">
                                    <div className="lg-md-lf-glv">
                                      <img src={document} alt="" />
                                      Invoice
                                    </div>
                                    {state?.invoiceDocument?.url ? (
                                          <span className="material-icons">navigate_next</span>
                                    ) : (
                                      "Not uploaded"
                                    )}

                                    <div className="loader">
                                      <img
                                        src={
                                              allbusiness?.invoiceDocument?.status === "APPROVED"
                                            ? checkbox
                                                : allbusiness.invoiceDocument?.status === "REJECTED"
                                                  ? rejectimg
                                                  : loaders
                                        }
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                </div>
                                {agreementDocument?.length !== 0 ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "16px",
                                    }}
                                  >
                                        <span className="typ_lg_vg">Lender's agreement</span>
                                    <div
                                      className="each_sec_lg_vgs"
                                      style={{
                                        border: "1px solid #e7e9fb",
                                        borderRadius: "8px",
                                        marginTop: "-20px !important",
                                      }}
                                    >
                                      <div className="lg-md-lf-glv">
                                        <img src={document2} alt="" />
                                        Lender's agreement
                                      </div>

                                          <span className="material-icons">navigate_next</span>

                                      <div className="loader">
                                        <img
                                          src={
                                            allSigned() === true
                                              ? checkbox
                                                  : agreementDocument?.status === "rejected"
                                                    ? rejectimg
                                                    : loaders2
                                          }
                                          alt=""
                                        />
                                      </div>
                                    </div>
                                        {anySigned() === false && allSigned() === false ? (
                                      <span
                                        style={{
                                          color: "#F04438",
                                          fontWeight: "600",
                                          fontSize: "14px",
                                          lineHeight: "19.6px",
                                        }}
                                      >
                                        Not Signed yet
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                        {anySigned() === true && allSigned() === false ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "10px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            color: "#039855",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            lineHeight: "19.6px",
                                          }}
                                        >
                                          Signed.
                                        </span>
                                        <span
                                          style={{
                                            color: "#667085",
                                            fontWeight: "500",
                                            fontSize: "14px",
                                            lineHeight: "19.6px",
                                          }}
                                        >
                                          Waiting for admin to counter-sign
                                        </span>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                ) : (
                                  ""
                                )}
                              </>
                            )}
                                {(isPaymentFinance && allbusiness?.paymentFinance?.swiftReference?.swiftType !== 'UETR') && (
                                  <div className="flex flex-col w-full gap-4">
                                    <div
                                      className="left-ttl-c"
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <span
                                        className="typ_lg_vg"
                                        style={{
                                          fontWeight: "500",
                                          color: "#667085",
                                          fontSize: "14px",
                                        }}
                                      >
                                        {allbusiness?.paymentFinance?.contractAgreement ? "Contract agreement" : 'Swift reference'}
                                      </span>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                          padding: "12px 16px",
                                          backgroundColor: "#F9FAFB",
                                          borderRadius: "8px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "12px",
                                          }}
                                          onClick={() => {
                                            const url = paymentFinanceDoc;
                                            if (url) {
                                              window.open(url, "_blank");
                                            }
                                          }}
                                        >
                                          <p
                                            style={{
                                              fontSize: "15px",
                                              fontWeight: "500",
                                              color: "#101828",
                                              margin: 0,
                                            }}
                                          >
                                            <FileDisplay
                                              url={paymentFinanceDoc}
                                              maxWidth="200px"
                                            />
                                          </p>
                                        </div>
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "12px",
                                          }}
                                        >
                                          <p
                                            style={{
                                              fontSize: "15px",
                                              fontWeight: "600",
                                              color: "#101828",
                                              margin: 0,
                                            }}
                                          ></p>
                                          <ChevronRight color="#667085" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {state.customtype !== "Payment" && (
                                  <>
                                    <div className="prof_ad_rf" style={{ cursor: "pointer" }}>
                                  <div className="left-ttl-c">
                                    {/* <span className="typ_lg_vg">Request details</span> */}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <div className="flex flex-col w-full gap-4">
                                      <div
                                        className="left-ttl-c"
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <span
                                          className="typ_lg_vg"
                                          style={{
                                            fontWeight: "500",
                                            color: "#667085",
                                            fontSize: "14px",
                                          }}
                                        >
                                          Bank statement (Last 3 months)
                                        </span>
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            padding: "12px 16px",
                                            backgroundColor: "#F9FAFB",
                                            borderRadius: "8px",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "12px",
                                            }}
                                            onClick={() => {
                                              const url = allbusiness?.bankStatement?.url;
                                              if (url) {
                                                window.open(url, "_blank");
                                              }
                                            }}
                                          >
                                            <p
                                              style={{
                                                fontSize: "15px",
                                                fontWeight: "500",
                                                color: "#101828",
                                                margin: 0,
                                              }}
                                            >
                                              <FileDisplay
                                                    url={allbusiness?.bankStatement?.name}
                                                maxWidth="200px"
                                              />
                                            </p>
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "12px",
                                            }}
                                          >
                                            <p
                                              style={{
                                                fontSize: "15px",
                                                fontWeight: "600",
                                                color: "#101828",
                                                margin: 0,
                                              }}
                                            ></p>
                                            <ChevronRight color="#667085" />
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="left-ttl-c"
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <span
                                          className="typ_lg_vg"
                                          style={{
                                            fontWeight: "500",
                                            color: "#667085",
                                            fontSize: "14px",
                                          }}
                                        >
                                              Board resolution to request capital from Tradevu
                                        </span>
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            padding: "12px 16px",
                                            backgroundColor: "#F9FAFB",
                                            borderRadius: "8px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            const url = allbusiness?.boardResolution?.url;
                                            if (url) {
                                              window.open(url, "_blank");
                                            }
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "12px",
                                            }}
                                          >
                                            <p
                                              style={{
                                                fontSize: "15px",
                                                fontWeight: "500",
                                                color: "#101828",
                                                margin: 0,
                                              }}
                                            >
                                              <FileDisplay
                                                    url={allbusiness?.boardResolution?.name}
                                                maxWidth="200px"
                                              />
                                            </p>
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "12px",
                                            }}
                                          >
                                            <p
                                              style={{
                                                fontSize: "15px",
                                                fontWeight: "600",
                                                color: "#101828",
                                                margin: 0,
                                              }}
                                            >
                                              {/* $12,000 */}
                                            </p>
                                            <ChevronRight color="#667085" />
                                          </div>
                                        </div>
                                      </div>

                                      {allbusiness?.signedAgreement && (
                                        <div className="flex flex-col mb-2 left-ttl-c">
                                          <span className="typ_lg_vg font-[500] text-[#667085] text-[14px]">
                                            Loan service agreement
                                          </span>
                                          <div
                                            className="flex items-center justify-between py-[12px] px-[16px] bg-[#F9FAFB] rounded-[8px] cursor-pointer"
                                            onClick={() => {
                                              const url = allbusiness?.signedAgreement;
                                              if (url) {
                                                window.open(url, "_blank");
                                              }
                                            }}
                                          >
                                            <div className="flex items-center gap-3">
                                              <p className="text-[15px] font-[500] text-[#101828] m-0">
                                                <FileDisplay
                                                      url={allbusiness?.signedAgreement}
                                                  maxWidth="200px"
                                                />
                                              </p>
                                            </div>
                                            <div className="flex items-center gap-[12px]">
                                              <p className="text-[15px] font-[500] text-[#101828] m-0">
                                                {/* $12,000 */}
                                              </p>
                                              <ChevronRight color="#667085" />
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                          {(isPaymentFinance && allbusiness?.disburseReceipt) && (
                                            <div className="flex flex-col mb-2 left-ttl-c">
                                              <span className="typ_lg_vg font-[500] text-[#667085] text-[14px]">
                                                Disburse receipt
                                              </span>
                                              <div
                                                className="flex items-center justify-between py-[12px] px-[16px] bg-[#F9FAFB] rounded-[8px] cursor-pointer"
                                                onClick={() => {
                                                  const url = allbusiness?.disburseReceipt;
                                                  if (url) {
                                                    window.open(url, "_blank");
                                                  }
                                                }}
                                              >
                                                <div className="flex items-center gap-3">
                                                  <p className="text-[15px] font-[500] text-[#101828] m-0">
                                                    <FileDisplay
                                                      url={allbusiness?.disburseReceipt}
                                                      maxWidth="200px"
                                                    />
                                                  </p>
                                                </div>
                                                <div className="flex items-center gap-[12px]">
                                                  <p className="text-[15px] font-[500] text-[#101828] m-0">
                                                    {/* $12,000 */}
                                                  </p>
                                                  <ChevronRight color="#667085" />
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                    </div>
                                        {allbusiness?.financeType === "payable_finance" ? (
                                      <>
                                        <div className="flex flex-col w-full gap-8 mb-4">
                                              {allbusiness?.payablebleFinance?.purchaseOrder
                                                ?.length && (
                                            <>
                                              <div
                                                className="left-ttl-c"
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                }}
                                              >
                                                <span
                                                  className="typ_lg_vg"
                                                  style={{
                                                    fontWeight: "500",
                                                    color: "#667085",
                                                    fontSize: "14px",
                                                  }}
                                                >
                                                  Purchase order
                                                </span>
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                        justifyContent: "space-between",
                                                    padding: "12px 16px",
                                                    backgroundColor: "#F9FAFB",
                                                    borderRadius: "8px",
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: "12px",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        width: "40px",
                                                        height: "40px",
                                                            backgroundColor: "#EEF4FF",
                                                        borderRadius: "8px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                            justifyContent: "center",
                                                      }}
                                                    >
                                                          <img src={document} alt="" />
                                                    </div>
                                                    <div>Purchase order</div>
                                                  </div>
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: "12px",
                                                    }}
                                                  >
                                                    <button
                                                      onClick={() =>
                                                            setShowPreview((prev) => !prev)
                                                      }
                                                      style={{
                                                        backgroundColor: "#fff",
                                                        // border: "1px solid #D0D5DD",
                                                        borderRadius: "6px",
                                                        padding: "6px 12px",
                                                        fontSize: "14px",
                                                        fontWeight: "500",
                                                        cursor: "pointer",
                                                        color: "#344054",
                                                      }}
                                                    >
                                                      Preview
                                                    </button>

                                                    {/* <ChevronRight color="#667085" /> */}
                                                  </div>
                                                </div>
                                              </div>
                                              <>
                                                <Preview
                                                      currency={allbusiness?.currency}
                                                  addTax={(
                                                    allbusiness?.payableFinance?.purchaseOrders[0]
                                                      ?.taxAmount || 0
                                                  ).toFixed(2)}
                                                  dueDate={
                                                    allbusiness?.payableFinance?.purchaseOrders[0]
                                                      ?.deliveryDate
                                                      ? dayjs(
                                                        allbusiness?.payableFinance
                                                          ?.purchaseOrders[0]?.deliveryDate,
                                                        ).format("MMM D, YYYY")
                                                      : "No due date"
                                                  }
                                                  note={
                                                    allbusiness?.payableFinance?.purchaseOrders[0]
                                                      ?.note
                                                  }
                                                  orderItems={
                                                    allbusiness?.payableFinance?.purchaseOrders[0]
                                                      ?.orderItems
                                                  }
                                                  paymentTerms={
                                                    allbusiness?.payableFinance?.purchaseOrders[0]
                                                      ?.paymentTerms
                                                  }
                                                  splitTerm="0"
                                                  subtotal={(
                                                    allbusiness?.payableFinance?.purchaseOrders[0]
                                                      ?.totalAmount || 0
                                                  ).toFixed(2)}
                                                  supplier={{
                                                    name: allbusiness?.payableFinance
                                                      ?.purchaseOrders[0]?.inbound?.businessName,
                                                    personalName:
                                                      allbusiness?.payableFinance?.purchaseOrders[0]
                                                        ?.inbound?.email,
                                                  }}
                                                  surCharge={(
                                                    allbusiness?.payableFinance?.purchaseOrders[0]
                                                      ?.surCharge || 0
                                                  ).toFixed(2)}
                                                  total={(
                                                    allbusiness?.payableFinance?.purchaseOrders[0]
                                                      ?.totalAmount || 0
                                                  ).toFixed(2)}
                                                  user={{
                                                    bizName:
                                                      allbusiness?.payableFinance?.purchaseOrders[0]
                                                        ?.outbound?.businessName,
                                                    bizImg: "",
                                                    fullName:
                                                      allbusiness?.payableFinance?.purchaseOrders[0]
                                                        ?.outbound?.email,
                                                  }}
                                                  preview={showPreview}
                                                      onClose={() => setShowPreview(false)}
                                                      setShowPreview={setShowPreview}
                                                />
                                              </>
                                            </>
                                          )}
                                              {allbusiness?.payableFinance?.financeCategory ===
                                            "transaction" && (
                                            <div className="flex flex-col left-ttl-c">
                                              <span className="typ_lg_vg font-[500] text-[#667085] text-[14px]">
                                                Transaction document
                                              </span>
                                              <div
                                                className="flex items-center justify-between py-[12px] px-[16px] bg-[#F9FAFB] rounded-[8px] cursor-pointer"
                                                onClick={() => {
                                                  const url =
                                                    allbusiness?.payableFinance?.transactionUrl;
                                                  if (url) {
                                                    window.open(url, "_blank");
                                                  }
                                                }}
                                              >
                                                <div className="flex items-center gap-3">
                                                  <p className="text-[15px] font-[500] text-[#101828] m-0">
                                                    <FileDisplay
                                                      url={
                                                            allbusiness?.payableFinance?.transactionUrl
                                                      }
                                                      maxWidth="200px"
                                                    />
                                                  </p>
                                                </div>
                                                <div className="flex items-center gap-[12px]">
                                                  <p className="text-[15px] font-[500] text-[#101828] m-0">
                                                    {/* $12,000 */}
                                                  </p>
                                                  <ChevronRight color="#667085" />
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                              {allbusiness?.financeType === "receivable_finance" && (
                                            <div
                                              className="left-ttl-c"
                                              style={{
                                                display: "flex",
                                                flexDirection: "column",
                                              }}
                                            >
                                              <span
                                                className="typ_lg_vg"
                                                style={{
                                                  fontWeight: "500",
                                                  color: "#667085",
                                                  fontSize: "14px",
                                                }}
                                              >
                                                Customer agreement
                                              </span>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                      justifyContent: "space-between",
                                                  padding: "12px 16px",
                                                  backgroundColor: "#F9FAFB",
                                                  borderRadius: "8px",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() => {
                                                  const url =
                                                    allbusiness?.receivableFinance?.uploadDocuments
                                                      ?.contractAgreement?.url;
                                                  if (url) {
                                                    window.open(url, "_blank");
                                                  }
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "12px",
                                                  }}
                                                >
                                                  <p
                                                    style={{
                                                      fontSize: "15px",
                                                      fontWeight: "500",
                                                      color: "#101828",
                                                      margin: 0,
                                                    }}
                                                  >
                                                    <FileDisplay
                                                      url={
                                                            allbusiness?.receivableFinance
                                                              ?.uploadDocuments?.contractAgreement?.url
                                                      }
                                                      maxWidth="200px"
                                                    />
                                                  </p>
                                                </div>
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "12px",
                                                  }}
                                                >
                                                  <p
                                                    style={{
                                                      fontSize: "15px",
                                                      fontWeight: "600",
                                                      color: "#101828",
                                                      margin: 0,
                                                    }}
                                                  >
                                                    {/* $12,000 */}
                                                  </p>
                                                  <ChevronRight color="#667085" />
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </>
                                    ) : null}
                                        {(allbusiness?.financeType === "receivable_finance" ||
                                          (allbusiness?.financeType === "payable_finance" &&
                                        (allbusiness?.status === "approved" ||
                                          allbusiness?.status === "repaid" ||
                                          allbusiness?.status === "cancelled" ||
                                              allbusiness?.status === "pending"))) && (
                                      <>
                                        <div
                                          className="left-ttl-c"
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          <span
                                            className="typ_lg_vg"
                                            style={{
                                              fontWeight: "500",
                                              color: "#667085",
                                              fontSize: "14px",
                                            }}
                                          >
                                            Customer agreement
                                          </span>
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "space-between",
                                              padding: "12px 16px",
                                              backgroundColor: "#F9FAFB",
                                              borderRadius: "8px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              const url =
                                                allbusiness?.payableFinance?.uploadDocuments
                                                  ?.contractAgreement?.url;
                                              if (url) {
                                                window.open(url, "_blank");
                                              }
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "12px",
                                              }}
                                            >
                                              <p
                                                style={{
                                                  fontSize: "15px",
                                                  fontWeight: "500",
                                                  color: "#101828",
                                                  margin: 0,
                                                }}
                                              >
                                                <FileDisplay
                                                  url="Contract agreement"
                                                  maxWidth="200px"
                                                />
                                              </p>
                                            </div>
                                            <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "12px",
                                              }}
                                            >
                                              <p
                                                style={{
                                                  fontSize: "15px",
                                                  fontWeight: "600",
                                                  color: "#101828",
                                                  margin: 0,
                                                }}
                                              >
                                                {/* $12,000 */}
                                              </p>
                                              <ChevronRight color="#667085" />
                                            </div>
                                          </div>
                                        </div>
                                            {allbusiness?.receivableFinance?.invoices?.length && (
                                          <>
                                            <div
                                              className="mt-2 left-ttl-c"
                                              style={{
                                                display: "flex",
                                                flexDirection: "column",
                                              }}
                                            >
                                              <span
                                                className="typ_lg_vg"
                                                style={{
                                                  fontWeight: "500",
                                                  color: "#667085",
                                                  fontSize: "14px",
                                                }}
                                              >
                                                Invoice order
                                              </span>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                      justifyContent: "space-between",
                                                  padding: "12px 16px",
                                                  backgroundColor: "#F9FAFB",
                                                  borderRadius: "8px",
                                                  cursor: "pointer",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "12px",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      width: "40px",
                                                      height: "40px",
                                                          backgroundColor: "#EEF4FF",
                                                      borderRadius: "8px",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                    }}
                                                  >
                                                        <img src={document} alt="" />
                                                  </div>
                                                  <div>Invoice order</div>
                                                </div>
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "12px",
                                                  }}
                                                >
                                                  <button
                                                        onClick={() => setShowPreview((prev) => !prev)}
                                                    style={{
                                                      backgroundColor: "#fff",
                                                      // border: "1px solid #D0D5DD",
                                                      borderRadius: "6px",
                                                      padding: "6px 12px",
                                                      fontSize: "14px",
                                                      fontWeight: "500",
                                                      cursor: "pointer",
                                                      color: "#344054",
                                                    }}
                                                  >
                                                    Preview
                                                  </button>

                                                  {/* <ChevronRight color="#667085" /> */}
                                                </div>
                                              </div>
                                            </div>
                                            <>
                                              <Preview
                                                currency={allbusiness?.currency}
                                                addTax={(
                                                  allbusiness?.receivableFinance?.invoices?.[0]
                                                    ?.taxAmount || 0
                                                ).toFixed(2)}
                                                dueDate={
                                                  allbusiness?.receivableFinance?.invoices?.[0]
                                                    ?.deliveryDate
                                                    ? dayjs(
                                                      allbusiness?.receivableFinance
                                                        ?.invoices?.[0]?.deliveryDate,
                                                      ).format("MMM D, YYYY")
                                                    : "No due date"
                                                }
                                                note={
                                                  allbusiness?.receivableFinance?.invoices?.[0]
                                                    ?.note
                                                }
                                                orderItems={
                                                  allbusiness?.receivableFinance?.invoices?.[0]
                                                    ?.orderItems
                                                }
                                                paymentTerms={
                                                  allbusiness?.receivableFinance?.invoices?.[0]
                                                    ?.paymentTerms
                                                }
                                                splitTerm="0"
                                                subtotal={(
                                                  allbusiness?.receivableFinance?.invoices?.[0]
                                                    ?.totalAmount || 0
                                                ).toFixed(2)}
                                                supplier={{
                                                  name: allbusiness?.receivableFinance
                                                    ?.invoices?.[0]?.inbound?.businessName,
                                                  personalName:
                                                    allbusiness?.receivableFinance?.invoices?.[0]
                                                      ?.inbound?.email,
                                                }}
                                                surCharge={(
                                                  allbusiness?.receivableFinance?.invoices?.[0]
                                                    ?.surCharge || 0
                                                ).toFixed(2)}
                                                total={(
                                                  allbusiness?.receivableFinance?.invoices?.[0]
                                                    ?.totalAmount || 0
                                                ).toFixed(2)}
                                                user={{
                                                  bizName:
                                                    allbusiness?.receivableFinance?.invoices?.[0]
                                                      ?.outbound?.businessName,
                                                  bizImg: "",
                                                  fullName:
                                                    allbusiness?.receivableFinance?.invoices?.[0]
                                                      ?.outbound?.email,
                                                }}
                                                preview={showPreview}
                                                    onClose={() => setShowPreview(false)}
                                                setShowPreview={setShowPreview}
                                              />
                                            </>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>

                                <div className="prof_ad_rf">
                                  {allbusiness?.cashFlowSupport && (
                                    <>
                                      <div
                                        className="left-ttl-c"
                                        style={{
                                          marginTop: "20px",
                                        }}
                                      >
                                            <span className="typ_lg_vg">Recommended Documents</span>
                                      </div>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          marginTop: "-20px",
                                        }}
                                      >
                                        <div
                                          className="each_sec_lg_vg"
                                          style={{
                                            border: "1px solid #e7e9fb",
                                            borderBottomLeftRadius: "0px",
                                            borderBottomRightRadius: "0px",
                                            cursor:
                                              allbusiness.status !== "SUBMITTED"
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          onClick={() => {
                                            if (
                                              allbusiness?.cashFlowSupport?.managementAccount
                                                ?.url &&
                                              allbusiness.status !== "SUBMITTED"
                                            ) {
                                              navigate("/finance/document", {
                                                state: {
                                                  image:
                                                    allbusiness?.cashFlowSupport?.managementAccount
                                                      ?.url,
                                                  type: "managementAccount",
                                                  id: state._id,
                                                  name: "TradeCredit",
                                                  seg: "single",
                                                },
                                              });
                                            }
                                          }}
                                        >
                                          <div className="lg-md-lf-glv">
                                            <img src={document} alt="" />
                                            Management Account
                                          </div>
                                              {allbusiness?.cashFlowSupport?.managementAccount?.url ? (
                                                <span className="material-icons">navigate_next</span>
                                          ) : (
                                            "Not uploaded"
                                          )}
                                          <div className="loader">
                                            <img
                                              src={
                                                    allbusiness.cashFlowSupport?.managementAccount
                                                  ?.status === "APPROVED"
                                                  ? checkbox
                                                      : allbusiness?.cashFlowSupport?.managementAccount
                                                        ?.status === "REJECTED"
                                                        ? rejectimg
                                                        : loaders
                                              }
                                              alt=""
                                            />
                                          </div>
                                        </div>
                                        <div
                                          className="each_sec_lg_vg"
                                          style={{
                                            border: "1px solid #e7e9fb",
                                            borderRadius: "0px",
                                            cursor:
                                              allbusiness.status !== "SUBMITTED"
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          onClick={() => {
                                            if (
                                              allbusiness?.cashFlowSupport?.agreement?.url &&
                                              allbusiness.status !== "SUBMITTED"
                                            ) {
                                              navigate("/finance/document", {
                                                state: {
                                                  image:
                                                    allbusiness?.cashFlowSupport?.agreement?.url,
                                                  type: "agreement",
                                                  id: state._id,
                                                  name: "TradeCredit",
                                                  seg: "single",
                                                },
                                              });
                                            }
                                          }}
                                        >
                                          <div className="lg-md-lf-glv">
                                            <img src={document} alt="" />
                                            Agreement
                                          </div>
                                              {allbusiness?.cashFlowSupport?.agreement?.url ? (
                                                <span className="material-icons">navigate_next</span>
                                          ) : (
                                            "Not uploaded"
                                          )}
                                          <div className="loader">
                                            <img
                                              src={
                                                    allbusiness?.cashFlowSupport?.agreement?.status ===
                                                "APPROVED"
                                                  ? checkbox
                                                      : allbusiness?.cashFlowSupport?.agreement
                                                        ?.status === "REJECTED"
                                                        ? rejectimg
                                                        : loaders
                                              }
                                              alt=""
                                            />
                                          </div>
                                        </div>
                                        <div
                                          className="each_sec_lg_vg"
                                          style={{
                                            border: "1px solid #e7e9fb",
                                            borderTopLeftRadius: "0px",
                                            borderTopRightRadius: "0px",
                                            cursor:
                                              allbusiness.status !== "SUBMITTED"
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          onClick={() => {
                                            if (
                                              allbusiness?.cashFlowSupport?.bankStatement?.url &&
                                              allbusiness.status !== "SUBMITTED"
                                            ) {
                                              navigate("/finance/document", {
                                                state: {
                                                  image:
                                                    allbusiness?.cashFlowSupport?.bankStatement
                                                      ?.url,
                                                  type: "bankStatement",
                                                  id: state._id,
                                                  name: "TradeCredit",
                                                  seg: "single",
                                                },
                                              });
                                            }
                                          }}
                                        >
                                          <div className="lg-md-lf-glv">
                                            <img src={document} alt="" />
                                            Bank Statement
                                          </div>
                                              {allbusiness?.cashFlowSupport?.bankStatement?.url ? (
                                                <span className="material-icons">navigate_next</span>
                                          ) : (
                                            "Not uploaded"
                                          )}
                                          <div className="loader">
                                            <img
                                              src={
                                                    allbusiness?.cashFlowSupport?.bankStatement
                                                      ?.status === "APPROVED"
                                                  ? checkbox
                                                      : allbusiness?.cashFlowSupport?.bankStatement
                                                        ?.status === "REJECTED"
                                                        ? rejectimg
                                                        : loaders
                                              }
                                              alt=""
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </div>
                                {allbusiness?.uploadDocuments &&
                                  state.customtype !== "Credit Line" && (
                                    <>
                                      <div
                                        className="left-ttl-c"
                                        style={{
                                          marginTop: "20px",
                                        }}
                                      >
                                          <span className="typ_lg_vg">Other Documents</span>
                                      </div>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          marginTop: "-20px",
                                        }}
                                      >
                                        <div
                                          className="each_sec_lg_vg"
                                          style={{
                                            border: "1px solid #e7e9fb",
                                            borderBottomLeftRadius: "0px",
                                            borderBottomRightRadius: "0px",
                                            cursor:
                                              allbusiness.status !== "SUBMITTED"
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          onClick={() => {
                                            if (
                                              allbusiness?.uploadDocuments?.certificateOfOrigin
                                                ?.url &&
                                              allbusiness.status !== "SUBMITTED"
                                            ) {
                                              navigate("/finance/document", {
                                                state: {
                                                  image:
                                                    allbusiness?.uploadDocuments
                                                      ?.certificateOfOrigin?.url,
                                                  type: "certificateOfOrigin",
                                                  id: state._id,
                                                  name:
                                                    state.customtype === "Credit Line"
                                                      ? "LetterOfCredit"
                                                      : "TradeCredit",
                                                  customtype: state.customtype,
                                                  seg: "single",
                                                },
                                              });
                                            }
                                          }}
                                        >
                                          <div className="lg-md-lf-glv">
                                            <img src={document} alt="" />
                                            Certificate of Origin
                                          </div>
                                            {allbusiness?.uploadDocuments?.certificateOfOrigin
                                              ?.url ? (
                                              <span className="material-icons">navigate_next</span>
                                          ) : (
                                            "Not uploaded"
                                          )}

                                          <div className="loader">
                                            <img
                                              src={
                                                  allbusiness?.uploadDocuments?.certificateOfOrigin
                                                  ?.status === "APPROVED"
                                                  ? checkbox
                                                  : allbusiness?.uploadDocuments
                                                      ?.certificateOfOrigin?.status === "REJECTED"
                                                      ? rejectimg
                                                      : loaders
                                              }
                                              alt=""
                                            />
                                          </div>
                                        </div>
                                        <div
                                          className="each_sec_lg_vg"
                                          style={{
                                            border: "1px solid #e7e9fb",
                                            borderRadius: "0px",
                                            cursor:
                                              allbusiness.status !== "SUBMITTED"
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          onClick={() => {
                                            if (
                                              allbusiness?.uploadDocuments?.packingList?.url &&
                                              allbusiness.status !== "SUBMITTED"
                                            ) {
                                              navigate("/finance/document", {
                                                state: {
                                                  image:
                                                    allbusiness?.uploadDocuments?.packingList?.url,
                                                  type: "packingList",
                                                  id: state._id,
                                                  name:
                                                    state.customtype === "Credit Line"
                                                      ? "LetterOfCredit"
                                                      : "TradeCredit",
                                                  customtype: state.customtype,
                                                  seg: "single",
                                                },
                                              });
                                            }
                                          }}
                                        >
                                          <div className="lg-md-lf-glv">
                                            <img src={document} alt="" />
                                            Packing List
                                          </div>
                                            {allbusiness?.uploadDocuments?.packingList?.url ? (
                                              <span className="material-icons">navigate_next</span>
                                          ) : (
                                            "Not uploaded"
                                          )}
                                          <div className="loader">
                                            <img
                                              src={
                                                  allbusiness?.uploadDocuments?.packingList
                                                    ?.status === "APPROVED"
                                                  ? checkbox
                                                    : state?.uploadDocuments?.packingList?.status ===
                                                      "REJECTED"
                                                      ? rejectimg
                                                      : loaders
                                              }
                                              alt=""
                                            />
                                          </div>
                                        </div>
                                        <div
                                          className="each_sec_lg_vg"
                                          style={{
                                            border: "1px solid #e7e9fb",
                                            borderTopLeftRadius: "0px",
                                            borderTopRightRadius: "0px",
                                            cursor:
                                              allbusiness.status !== "SUBMITTED"
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          onClick={() => {
                                            if (
                                              allbusiness?.uploadDocuments?.inspectionCertificate
                                                ?.url &&
                                              allbusiness.status !== "SUBMITED"
                                            ) {
                                              navigate("/finance/document", {
                                                state: {
                                                  image:
                                                    allbusiness?.uploadDocuments
                                                      ?.inspectionCertificate?.url,
                                                  type: "inspectionCertificate",
                                                  id: state._id,
                                                  name:
                                                    state.customtype === "Credit Line"
                                                      ? "LetterOfCredit"
                                                      : "TradeCredit",
                                                  customtype: state.customtype,
                                                  seg: "single",
                                                },
                                              });
                                            }
                                          }}
                                        >
                                          <div className="lg-md-lf-glv">
                                            <img src={document} alt="" />
                                            Certificate of Inspection
                                          </div>
                                            {allbusiness?.uploadDocuments?.inspectionCertificate
                                              ?.url ? (
                                              <span className="material-icons">navigate_next</span>
                                          ) : (
                                            "Not uploaded"
                                          )}
                                          <div className="loader">
                                            <img
                                              src={
                                                  allbusiness?.uploadDocuments?.inspectionCertificate
                                                  ?.status === "APPROVED"
                                                  ? checkbox
                                                    : state?.uploadDocuments?.inspectionCertificate
                                                      ?.status === "REJECTED"
                                                      ? rejectimg
                                                      : loaders
                                              }
                                              alt=""
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                {agreementDocument?.length !== 0 ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "16px",
                                    }}
                                  >
                                        <span className="typ_lg_vg">Lender's agreement</span>
                                    <div
                                      className="each_sec_lg_vgs"
                                      style={{
                                        border: "1px solid #e7e9fb",
                                        borderRadius: "8px",
                                        marginTop: "-20px !important",
                                      }}
                                    >
                                      <div className="lg-md-lf-glv">
                                        <img src={document2} alt="" />
                                        Lender's agreement
                                      </div>

                                          <span className="material-icons">navigate_next</span>

                                      <div className="loader">
                                        <img
                                          src={
                                            allSigned() === true
                                              ? checkbox
                                                  : agreementDocument?.status === "rejected"
                                                    ? rejectimg
                                                    : loaders2
                                          }
                                          alt=""
                                        />
                                      </div>
                                    </div>
                                        {anySigned() === false && allSigned() === false ? (
                                      <span
                                        style={{
                                          color: "#F04438",
                                          fontWeight: "600",
                                          fontSize: "14px",
                                          lineHeight: "19.6px",
                                        }}
                                      >
                                        Not Signed yet
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                        {anySigned() === true && allSigned() === false ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "10px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            color: "#039855",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            lineHeight: "19.6px",
                                          }}
                                        >
                                          Signed.
                                        </span>
                                        <span
                                          style={{
                                            color: "#667085",
                                            fontWeight: "500",
                                            fontSize: "14px",
                                            lineHeight: "19.6px",
                                          }}
                                        >
                                          Waiting for admin to counter-sign
                                        </span>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                ) : (
                                  ""
                                )}
                              </>
                            )}
                          </>
                        )}

                        {tab === "bank" && (
                          <>
                            {state.customtype === "Working Capital" && (
                              <div className="section_modl_lg">
                                <div className="bank-detail-other">
                                  <div className="level-bank-details">
                                    <span>Name</span>
                                    <div>
                                          {allbusiness?.firstName} {allbusiness?.lastName}
                                    </div>
                                  </div>
                                  <div className="level-bank-details">
                                    <span>Email</span>
                                    <div>{allbusiness?.email}</div>
                                  </div>
                                  <div className="level-bank-details">
                                    <span>Phone Number</span>
                                    <div>{allbusiness?.phoneNumber}</div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {state.customtype === "Factoring" &&
                                  state?.invoice?.invoiceItems?.map((res, index) => (
                                    <div className="main-lg-request" key={index}>
                                      <div className="each-request">
                                        <div className="img-name">
                                          <img src={factoring} alt="" />
                                          <div
                                            className="mytag-lg"
                                            style={{
                                              gap: "0px",
                                            }}
                                          >
                                            <div className="head-tg">{res.itemName}</div>
                                            <span
                                              className="small-tg"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "4px",
                                              }}
                                            >
                                              Quantity : {res.quantity} Price Per Unit :{" "}
                                              {allbusiness?.currency === "NGN"
                                                ? "₦"
                                                : allbusiness?.currency === "USD"
                                              ? "$"
                                              : allbusiness?.currency === "EUR"
                                                    ? "€"
                                                    : "£"}
                                              {parseFloat(res.pricePerUnit).toLocaleString()}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="mytag-lg">
                                          <div
                                            className="head-tg"
                                            style={{
                                              color: "#344054",
                                              fontSize: "14px",
                                              fontWeight: "600",
                                              lineHeight: "19.6px",
                                              textAlign: "right",
                                            }}
                                          >
                                            {allbusiness?.currency === "NGN"
                                              ? "₦"
                                              : allbusiness?.currency === "USD"
                                            ? "$"
                                            : allbusiness?.currency === "EUR"
                                                  ? "€"
                                                  : "£"}
                                            {parseFloat(
                                              res.pricePerUnit * res.quantity,
                                            ).toLocaleString()}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                          </>
                        )}
                        {tab === "repay" && (
                          <>
                            <div
                              className="section_modl_lg"
                              style={{
                                position: "relative",
                              }}
                            >
                              {success && (
                                <div
                                  className="success"
                                  style={{
                                    width: "100%",
                                    boxSizing: "border-box",
                                    zIndex: "9999",
                                  }}
                                >
                                  <div className="lg-success">
                                    <div className="ech-lg-hm">
                                      <div className="main-sucees">Success</div>
                                      <span
                                        style={{
                                          fontSize: "12px",
                                        }}
                                      >
                                        {message}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {fail && (
                                <div
                                  className="success"
                                  style={{
                                    background: "#FCFCFD",
                                    border: " 1px solid #D0D5DD",

                                    boxSizing: "border-box",
                                    zIndex: "9999",
                                    width: "100%",
                                  }}
                                >
                                  <div className="lg-success">
                                    <div
                                      className="ech-lg-hm"
                                      style={{
                                        background: "#F9FAFB",
                                      }}
                                    >
                                      <div
                                        className="main-sucees"
                                        style={{
                                          color: "#344054",
                                        }}
                                      >
                                        Failed
                                      </div>
                                      <span
                                        style={{
                                          color: "#344054",
                                        }}
                                      >
                                        {message}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              )}
                              <div className="bank-detail-other">
                                <div className="new_line_credit_detail">
                                  <div className="each_line_credit_line">
                                    <div className="line_each_dl">
                                          <span className="initial_each_dl">Initial Request</span>
                                      <span className="amount_dl">
                                        {" "}
                                        {state.currency === "NGN"
                                          ? "₦"
                                          : state.currency === "EUR"
                                                ? "€"
                                                : state.currency === "USD"
                                                  ? "$"
                                                  : "£"}
                                        {allbusiness.requestedAmount}
                                      </span>
                                    </div>
                                    <div className="line_each_dl">
                                          <span className="initial_each_dl">Approved Tenure</span>
                                          <span className="amount_dl">{allbusiness.tenure} Days</span>
                                    </div>
                                  </div>
                                  <div className="each_line_credit_line">
                                    <div className="line_each_dl">
                                          <span className="initial_each_dl">Approved Amount</span>
                                      <span className="amount_dl">
                                        {" "}
                                        {state.currency === "NGN"
                                          ? "₦"
                                          : state.currency === "EUR"
                                                ? "€"
                                                : "£"}
                                        {allbusiness.loanAmount}
                                      </span>
                                    </div>
                                    <span className="date_my_lie">
                                          {new Date(state.createdAt).toLocaleTimeString()}
                                    </span>
                                  </div>
                                </div>

                                <div className="balance_detail_lg_con">
                                  <div className="level-bank-details">
                                    <span>Wallet Balance</span>
                                    <div
                                      style={{
                                        fontWeight: "500",
                                        fontSize: "16px",
                                        color: "#101828",
                                        letterSpacing: "2%",
                                        lineHeight: "24px",
                                      }}
                                    >
                                      {filterwallet?.length > 0 ? (
                                        <>
                                          {" "}
                                          {state.currency === "NGN"
                                            ? "₦"
                                            : state.currency === "EUR"
                                                  ? "€"
                                                  : "£"}
                                          {filterwallet?.map((item) => (
                                            <>{parseFloat(item?.balance).toLocaleString()}</>
                                          ))}
                                        </>
                                      ) : (
                                        <>{parseFloat(0).toLocaleString()}</>
                                      )}
                                    </div>
                                  </div>
                                  <div className="img_balance_logo">
                                    <img
                                      src={
                                        state.currency === "NGN"
                                          ? NGN
                                          : state.currency === "EUR"
                                                ? US
                                                : state.currency === "GBP"
                                                  ? GBP
                                                  : EU
                                      }
                                      alt=""
                                      style={{
                                        height: "24px",
                                        width: "24px",
                                      }}
                                    />
                                    <span
                                      className="material-icons"
                                      style={{
                                        fontSize: "10px",
                                      }}
                                    >
                                      expand_more
                                    </span>
                                  </div>
                                </div>
                                    {allbusiness?.disbursementDate !== undefined && (
                                  <div className="new_lag_repayment">
                                        <span className="repaymentdetails">Repayment Details</span>
                                    <div className="new_linw_gl">
                                      <div
                                        className="each_section_lp"
                                        style={{
                                          borderBottom: "1px solid #E7E9FB",
                                          borderTop: "1px solid #E7E9FB",
                                        }}
                                      >
                                        <div className="level-bank-details">
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              width: "100%",
                                            }}
                                          >
                                            <span className="repayment_stage">
                                              Repayment(
                                                  {filterloanrepaid?.length}/{loans?.length})
                                            </span>
                                            <span className="competetion_rate">
                                              {parseFloat(
                                                filterloanrepaid?.length / loans?.length,
                                              ).toFixed(2) * 100}
                                              % Complete
                                            </span>
                                          </div>
                                          <div
                                            style={{
                                              position: "relative",
                                              background: "#EAECF0",
                                              borderRadius: "20px",
                                              width: "100%",
                                              height: "16px",
                                            }}
                                          >
                                            <div
                                              style={{
                                                position: "absolute",
                                                background: "#12B76A",
                                                width: `calc(${parseFloat(
                                                  filterloanrepaid?.length / loans?.length,
                                                ).toFixed(2)} * 100%)`,
                                                height: "100%",
                                                borderRadius: "20px",
                                              }}
                                            ></div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="each_section_lp"
                                        style={{
                                          display: "flex",
                                          gap: "16px",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                        }}
                                      >
                                        <div className="level-bank-details">
                                          <span>Next Payment</span>
                                          <div>
                                            {filterloan?.length > 0 ? (
                                              <>
                                                {" "}
                                                    {currencyPairCheck(state.currency)}
                                                    {firstloan?.map((item) => item?.amount)}
                                              </>
                                            ) : (
                                              "Repaid fully"
                                            )}
                                          </div>
                                        </div>
                                        <div className="level-bank-details">
                                          <span>Next Payment On</span>
                                          <div>
                                            {filterloan?.length > 0
                                              ? firstloan?.map((item) =>
                                                new Date(item?.dueDate).toDateString(),
                                                )
                                              : "Repaid fully."}
                                          </div>
                                        </div>
                                        <div className="level-bank-details">
                                          <span>Repayment Structure</span>
                                          <div>
                                            {" "}
                                                {state?.repaymentStructure === "InterestFirst"
                                              ? "Interest First"
                                                  : state?.repaymentStructure === "FullPayment"
                                                    ? "Full Payment"
                                                    : state?.repaymentStructure}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {filterloan?.length > 0 && (
                                  <button
                                    className="repay-for"
                                    disabled={loader}
                                    type="button"
                                    onClick={RepayNow}
                                  >
                                    {loader ? <Loading /> : "Repay Loan"}
                                  </button>
                                )}
                              </div>
                            </div>
                          </>
                        )}
                        {tab === "term" && (
                          <>
                            <div
                              className="section_modl_lg"
                              style={{
                                position: "relative",
                              }}
                            >
                              <div className="bank-detail-other">
                                <div className="level-bank-details">
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      width: "100%",
                                    }}
                                  >
                                    <span>
                                          Repayment({filterloanrepaid?.length}/{loans?.length})
                                    </span>
                                    <span>
                                          {parseFloat(filterloanrepaid?.length / loans?.length).toFixed(
                                            2,
                                          ) * 100}
                                      % Complete
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      position: "relative",
                                      background: "#EAECF0",
                                      borderRadius: "20px",
                                      width: "100%",
                                      height: "16px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        position: "absolute",
                                        background: "#12B76A",
                                        width: `calc(${parseFloat(
                                          filterloanrepaid?.length / loans?.length,
                                        ).toFixed(2)} * 100%)`,
                                        height: "100%",
                                        borderRadius: "20px",
                                      }}
                                    ></div>
                                  </div>
                                </div>
                                <div className="level-bank-details">
                                  <span>Next Payment</span>
                                  <div>
                                    {filterloan?.length > 0 ? (
                                      <>
                                        {" "}
                                        {currencyPairCheck(state.currency)}
                                        {firstloan?.map((item) => item?.amount)}
                                      </>
                                    ) : (
                                      "Repaid fully"
                                    )}
                                  </div>
                                </div>
                                <div className="level-bank-details">
                                  <span>Next Payment In</span>
                                  <div>
                                    {filterloan?.length > 0
                                      ? firstloan?.map((item) =>
                                        new Date(item?.dueDate).toDateString(),
                                        )
                                      : "Repaid fully."}
                                  </div>
                                </div>
                                <div className="level-bank-details">
                                  <span>Repayment Structure</span>
                                  <div>{allbusiness?.repaymentStructure}</div>
                                </div>
                                {filterloan?.length > 0 && (
                                  <button
                                    className="repay-for"
                                    disabled={loader}
                                    type="button"
                                    onClick={RepayNow}
                                  >
                                    {loader ? <Loading /> : "Repay"}
                                  </button>
                                )}
                              </div>
                            </div>
                          </>
                        )}
                        {tab === "goods" && (
                          <>
                            <div
                              className="section_modl_lg"
                              style={{
                                border: "1px solid #e7e9fb",
                                padding: "10px",
                                borderRadius: "8px",
                              }}
                            >
                              <div className="bank-detail-other">
                                <div className="level-bank-details">
                                  <span>Supplier Details</span>
                                      <div>{state?.typesOfGoods ? state.typesOfGoods : "nill"}</div>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default FinanceDetails;
